
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Edit, ErrorOutline, Check, InfoOutlined as InfoIcon } from '@material-ui/icons';
import { Grid, Typography, Stepper, Step, StepLabel, StepButton, StepConnector, LinearProgress, Button, Tooltip } from '@material-ui/core';
import { WithStyles, createStyles } from '@material-ui/core';
import Switch from '@material-ui/core/Switch';
import { withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import _ from 'lodash';
import { MyPATCollapse, MyPATLink, MyPATDialog, MyPATTextArea } from '../../common';


import { statusType } from '../types/ContentInSection'
import ContentData from '../types/ContentData';
import { ContentInSection, commonHeader, matrixSection, indexOfCommonSection, paragraphHeader, 
paragraphSection, indexOfParagraphInSection, integerHeader, integerSection, descriptiveHeader,
descriptiveSection, paragraphInnerHeader, paragraphInnerHeaderInteger, indexOfParagraphInSectionInteger, 
notesMaterial, formulaMaterial, testPaper, sampleProblem, videoDetailsMaterial, audioDetailsMaterial, indexOfParagraphInSectionMatrix,
descriptiveSectionKeys, descriptiveHeaderSideTitles  } from '../types/ContentInSection';

import contentService from '../services/contentService';

import ContentAuthorModal from './ContentAuthorModal';
import ContentPublishedModal from './ContentPublishedModal';
import ContentTagData from '../types/ContentTagData';
import ContentFormData from '../types/ContentFormData';
import ContentFormDataError from '../types/ContentFormDataError';
import ACL from '../../acl/components/ACL';
import ACLService from '../../acl/services/aclService';
import ContentReviwerModal from './ContentReviwerModal';
import RepublishContentModal from './RepublishContentModal';
import CustomInfoIcon from '../../common/CustomInfoIcon';
import { AUTHORING_CONTENT_TYPES, CONTENT_SECTION_KEYS, CONTENT_STATES, CONTENT_STATUS, CONTENT_TYPE, QUESTION_TYPE, QUESTION_TYPES, USER_TYPE } from '../../../constants/comman';
import { isQuestionAddToQueueModeActiveParagraph, checkIsCorrectAnswerChangeParagraph, getParagraphUpdatedIndex, convertSubjectWithId, validateStepWiseSolutions, scrollIntoView, isConceptAndChapterAddToQueueModeActive, isDifficultyAndSkillAddToQueueModeActive, getPropertyValue, getUserType, checkForTeacherUser } from '../../../utils';
import AddToQueueQuestion from '../../common/AddToQueueQuestion';
import { getQuestionTypeName } from './ContentCreate/ParagraphCreate';
import { Prompt } from 'react-router-dom';
import Benchmark from './Benchmark';
import contentActions from '../actions/contentActions';
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";
import { contentRequestAccordianActions } from '../../content-request/reducers/contentRequestAccordianState';
import contentRequestServices from '../../content-request/services/contentRequestServices';
import classNames from 'classnames';
import { showMsg as showAlert } from '../../course/actions/loaderAlert';
import { setCustomAnswerKey } from '../helper/questionTab';
import { REMEDIAL_PAGE_KEY } from './ContentCreate/RemedialComponent/RemedialQuestionConstants';
import { CONTENT_SUBMIT_MODAL_BODY, FEEDBACK_VALIDATOR_ACTIONS, QUESTION_SUBMIT } from '../helper/contentValidation';
import PublishContentDirecltyModal from './PublishContentDirecltyModal';

const styles = (theme: Theme) =>
  createStyles({
    iOSSwitchBase: {
      '&$iOSChecked': {
        color: theme.palette.common.white,
        '& + $iOSBar': {
          backgroundColor: '#52d869',
        },
      },
      transition: theme.transitions.create('transform', {
        duration: theme.transitions.duration.shortest,
        easing: theme.transitions.easing.sharp,
      }),
    },
    iOSChecked: {
      transform: 'translateX(18px)',
      '& + $iOSBar': {
        opacity: 1,
        border: 'none',
      },
    },
    iOSBar: {
      borderRadius: 13,
      width: 44,
      height: 22,
      marginTop: -11,
      marginLeft: -20,
      border: 'solid 1px',
      borderColor: '#999',
      backgroundColor: '#999',
      opacity: 1,
      transition: theme.transitions.create(['background-color', 'border']),
    },
    iOSIcon: {
      width: 20,
      height: 20,
    },
    iOSIconChecked: {
      boxShadow: theme.shadows[1],
    },
    directPublish: {
      width: 792,
      padding: '15px 20px',
      borderRadius: 4,
      background: '#F4F4F4',
      display: 'flex',
      gap: '15px',
      textAlign: 'left',
      marginRight: 'auto',
      alignItems: 'center',
      justifyContent: 'center',
    },
    directPublishText: {
      fontSize: 20,
      color: '#666',
      lineHeight: '26px',
      fontWeight: 400,
    },
    tootipContainer: {
      bottom: 63,
      position: "absolute",
      width: "86%",
      margin: "0px 38px",
      "&::before": {
        position: "absolute",
        width: 0,
        height: 0,
        bottom: -9,
        right: 10,
        borderLeft: "5px solid rgba(0, 0, 0, 0)",
        borderRight: "5px solid rgba(0, 0, 0, 0)",
        borderTop: "12px solid rgb(0 0 0)",
        content: '""',
      },
    },
    rePublishButton: {
      "&:hover ::after": {
        // position: 'absolute',
        // width: 0,
        // height: 0,
        // bottom: 29,
        // right: 10,
        // borderLeft: '5px solid rgba(0, 0, 0, 0)',
        // borderRight: '5px solid rgba(0, 0, 0, 0)',
        // borderTop: '12px solid rgb(0 0 0)',
        // content: '""'
      },
      "&>p": {
        opacity: 1,
      },
    },
    active: {
      color: theme.palette.error.light,
    },
    successIcon: {
      backgroundColor: "#379D0B",
    },
    primaryColor: {
      backgroundColor: theme.palette.primary.main,
    },
    warningIcon: {
      color: "#FF4A4A !important",
      padding: "0 !important",
      transform: "scale(1.3)",
    },
    positionAb: {
      position: "absolute",
      right: "5px",
      top: "4px",
      color: "#666666",
      textShadow: "0px 0px 2px #FFF",
      fontSize: "14px",
    },
    focusedStep: {
        backgroundColor: '#FAFCFF',
        padding: '10px 10px 10px 0',
        borderRadius: "4px",    
    },
    publishedLabel: {
      position: "absolute",
      right: "0",
      left: "0",
      top: "4px",
      color: "#666666",
      textShadow: "0px 0px 2px #FFF",
      fontSize: "14px",
      cursor: "pointer",
    },
    positionRl: {
      position: "relative",
    },
    icon: {
      color: theme.palette.primary.contrastText,
      borderRadius: 15,
      padding: "3px",
      margin: 0,
      fontSize: 28,
    },
    editIcon: {
      fontSize: 16,
    },
    connectorLine: {
      borderColor: "transparent",
      margin: "0px -2px 0px",
      //minHeight:'100%',
    },
    defaultIcon: {
      backgroundColor: theme.palette.primary.contrastText,
    },
    p15: {
      padding: theme.spacing.unit * 2,
      height: "auto",
      overflow: "auto",
    },
    overflowSection: {
      overflow: "auto",
      height: "auto",
      padding: theme.spacing.unit * 2,
      backgroundColor: 'transparent',
      "&>:nth-child(2)": {
        padding: 0,
      },
    },
    innerConnecter: {
      "&:after": {
        minHeight: "32px",
        borderLeftStyle: "solid",
        borderLeftWidth: "1px",
        margin: "21px -10px -5px",
        borderColor: "#E4E4E4",
        content: '""',
        marginTop: "20px",
        position: "absolute",
      },
    },
    progressBar: {
      borderRadius: 5,
    },
    addOptionButton: {
      textAlign: "center",
    },
    moveToPlannedContainer: {
      marginTop: theme.spacing.unit * 3,
      marginBottom: theme.spacing.unit,
      marginLeft: -theme.spacing.unit * 2,
      marginRight: -theme.spacing.unit * 2,
      paddingLeft: theme.spacing.unit * 2,
      paddingRight: theme.spacing.unit * 2,
      position: "relative",
      borderTop: "1px solid #ededed",
    },
    moveToPlannedOr: {
      position: "absolute",
      left: "50%",
      transform: "translateY(-50%) translateX(-50%)",
      fontSize: "12px",
      background: "#ededed",
      color: "#adadad",
      padding: theme.spacing.unit,
      borderRadius: "100%",
    },
    moveToPlanned: {
      borderRadius: "18px",
      width: "100%",
      marginTop: theme.spacing.unit * 4,
    },
    modalBody: {
      width: "900px",
      paddingBottom: "47px",
      paddingTop: "35px",
      textAlign: "center",
    },
    publishText: {
      fontWeight: "normal",
      fontSize: "16px",
      lineHeight: "24px",
      textAlign: "center",
      width: "577px",
      margin: "20px auto 0 auto",
      display: "block",
    },
    quesIdContainer: {
      padding: "15px",
      width: "100%",
      textAlign: "center",
    },
    quesId: {
      border: "solid 1px #2196F3",
      color: "#2196F3",
      padding: "5px 14px 5px 14px",
      textAlign: "center",
      fontSize: "16px",
      lineHeight: "16px",
      borderRadius: "4px",
      textDecoration: "none",
      margin: "10px",
      background: "#ffffff",
    },
    modalFooter: {
      textAlign: "center",
      padding: "10px 0 20px 0",
    },
    refreshBtn: {
      color: "#ffffff",
      padding: "0 16px",
      background: "linear-gradient(90deg, #2E93FB 0%, #66b4fd 70%)",
      height: "36px",
      fontSize: "0.875rem",
      minWidth: "64px",
      boxSizing: "border-box",
      lineHeight: "1.75",
      fontFamily: "'Roboto', sans-serif",
      "font-weight": "normal",
      borderRadius: "4px",
      backgroundColor: "#2E93FB",
      border: "solid 1px #2E93FB",
      display: "inline-block",
      width: "140px",
    },
    okBtn: {
      color: "#2E93FB",
      padding: "0 16px",
      background: "#ffffff",
      height: "36px",
      fontSize: "0.875rem",
      minWidth: "64px",
      boxSizing: "border-box",
      lineHeight: "1.75",
      fontFamily: "'Roboto', sans-serif",
      "font-weight": "normal",
      borderRadius: "4px",
      marginLeft: "18px",
      display: "inline-block",
      width: "140px",
      border: "solid 1px #2E93FB",
    },
    republishTitle: {
      color: "#333333",
      fontSize: "24px",
      fontWeight: 600,
    },
    customRepublishDialog: {
      minWidth: "550px",
      width: "100%",
    },
    cancelBorder: {
      border: "1px solid #1D7DEA",
    },
    stepDisabled: {
      padding: 0,
      "&>:first-child": {
        marginBottom: 0,
      },
    },
    paddingZero: {
      paddingBottom: 0,
    },
    footerFixed: {
      position: "fixed",
      zIndex: 100,
      right: 0,
      width: "100%",
      bottom: 0,
      textAlign: "right",
      backgroundColor: "#ffffff",
      paddingRight: "26px",
      padding: "15px 24px",
      boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.1)",
      display: 'flex',
      justifyContent: 'right',
      gridTemplateColumns: "85% 15%",
      alignItems: "center",
        '& .instruction': {
            margin: '0 auto 0 0',
            width: '50%',
            maxWidth: '473px',
            fontSize: '20px',
            fontWeight: 400,
            color: '#666666',
            textAlign: 'left'

        },
      "& button": {
        padding: "10px 8px",
      },
    },
    footerForReValidation: {
        gridTemplateColumns: 'auto 205px 205px',
        gap: '15px',
      },
    linearProgressBar: {
      borderRadius: 5,
      padding: 2,
      margin: "4px 8px",
      backgroundColor: "#E8E8E8",
      width: "82px",
      minWidth: 85,
      display: "inline-block",
      verticalAlign: "middle",
    },
    progressPercent: {
      fontSize: 14,
      color: "#333",
      fontWeight: 600,
    },
    colorSecondary: {
      backgroundColor: "#EB4F4F",
      color: "5.5px 5px 5px 5.5px",
    },
    colorprimary: {
      backgroundColor: "#67BF02",
    },
    colorSuccess: {
      backgroundColor: "#67BF02",
      color: "5.5px 5px 5px 5.5px",
    },
    progressLabel: {
      fontSize: 14,
      color: "#999",
    },
    progressCount: {
      fontSize: 14,
      color: "#333",
      fontWeight: 600,
    },
    progressParent: {
      display: "flex",
      alignItems: "center",
    },
    displayFlex: {
      display: "flex",
      justifyContent: "flex-end",
      alignItems: "center",
      flexDirection: "row-reverse",
      maxWidth: 220,
      width: "100%",
      marginLeft: "auto",
    },
    cursorPointer: {
      cursor: "pointer",
    },
    numberLabel: {
      width: 28,
      height: 28,
      borderRadius: "50%",
      border: "1px solid #dcdcdc",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    btnText: {
        border: 'none !important',
        fontSize: '14px',
        fontWeight: 600,
        color: '#1D7DEA !important',
        whiteSpace: 'nowrap',
        '&:disabled': {
          opacity: 0.41,
        }
      },
      btnFill: {
          fontSize: '14px',
          fontWeight: 600,
          padding: '5px 10px',
          whiteSpace: 'nowrap',
      },
      progressText: {
          justifyContent: 'inherit',
      },
      rejectionModal: {
          textAlign: 'center',
          maxWidth: '400px',
          margin: '0 auto',
          '& img': {
              display: 'block',
              margin: '0 auto 33px',
          },
          '& h2': {
              fontSize: '24px',
              fontWeight: 600,
              lineHeight: '138%',
              color: '#333333',
              margin: '0 0 10px',
          },
          '& p': {
              fontSize: '16px',
              fontWeight: 400,
              lineHeight: '150%',
              color: '#666666',
              margin: '0 0 20px',
          }
      },
      rejectionModalFooter: {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: '100%',
          margin: '0 0 16px',
          '& .modalBtnText': {
              fontSize: '16px',
              fontWeight: 500,
              color: '#1D7DEA',
              padding: '5px 10px',
              minHeight: '44px',
              minWidth: '94px',
              margin: '0 4px',
          },
          '& .modalBtnFill': {
              fontSize: '16px',
              fontWeight: 500,
              color: '#ffffff',
              backgroundColor: '#1D7DEA',
              minWidth: '94px',
              padding: '5px 10px',
              minHeight: '44px',
              margin: '0 4px',
          }
      }
  });


const addQuestionStringInId = (id: string) => {
    return id.indexOf('question') === -1 ? id + 'question' : id
}
const getQuestionsFromFormData = (formData: any) => {
    const draft100Percent: any[] = []
    const draftLessThan100Percent: any[] = []
    formData.data.sections.forEach((sections: any) => {
        sections.subSection.forEach((subSection: any) => {
            subSection.questions.forEach((question: any) => {
                if (question.content_Id.status === 'DRAFT') {
                    if (question.content_Id.completionPercent < 100) {
                        draftLessThan100Percent.push({
                            contentId: question.content_Id.contentId,
                            _id: addQuestionStringInId(question.content_Id._id),
                        })
                    } else {
                        draft100Percent.push({
                            contentId: question.content_Id.contentId,
                            _id: addQuestionStringInId(question.content_Id._id)
                        })
                    }
                }
            })
        })
    })
    return { draft100Percent, draftLessThan100Percent }
}

const emptyLatexValue = ['<p> <br></p>', '<p><br></p>']

//@ts-ignore
interface SectionsInContentWithProps extends WithStyles<typeof styles> {
    classes: any,
    focusedSection: { currentlyFocusedSection: string; sectionsTouched: Set<string> },
    formData: any,
    originalFormData: any,
    sectionCurrentlyEditing?: string;
    formDataError: ContentFormDataError,
    changeFormDataError: Function,
    match: any,
    eventInContent: any,
    queryParams: any,
    history: any,
    paragraphInSection: any,
    completionPercent: any,
    content: ContentData,
    tagsList: ContentTagData[],
    updateFormData: Function,
    moveToPlanned: Function,
    publishContent: Function,
    fromURL: any,
    selectedQuestionsList: any[],
    publishedStateQuestion: any[],
    draftStateQuestion: any[],
    completeDraftStateQuestion: any[],
    testSubjects: any[],
    save: Function,
    hasMyLibraryQueue: boolean,
    isValidAttempts: boolean,
    defaultCorrectAnswersForParagraph: any,
    notesSubTypes: any,
    fetchGoalLevels: Function,
    updateBenchMarkInfo: Function,
    isTemplateChanged: boolean,
    templateChanged: Function,
    questionCompleted: Function,
    authenticatedUser: any,
    accordianCreateTouched: any,
    setAccordingTouchIndex: Function,
    setAccordianTouchWhileCreate: Function,
    accordianTest: any,
    setTestAccordian: Function,
    isComingFromTest: boolean,
    fromFeedback: boolean,
    sliderData?: any;
    currentQuestionNumber?: number,
    currentTestNumber: number,
    authorType: string;
    feedBackData: any;
    onFeedbackPublish?: Function,
    setContentRequestItemsIdForFirstTime: Function,
    setIsBothTabOpen: Function,
    setProgressBarForTest: Function,
    setAccordianState: Function,
    setIsComingFrom: Function,
    setProgressBarForQuestion: Function,
    setIsComingFromTest: Function,
    setIsTabOpened: Function,
    setFilterQuestionArray: Function,
    setRemoveUnresolvedFeedbackCount: Function,
    setRemoveUnresolvedFeedbackCountForTest: Function,
    showMsg:Function,
    isQuestionUpdated: boolean,
    isFtre: boolean,
    validationStatus:string;
    pendingValidationComments?: boolean;
    canSubmitToAnotherValidator: boolean;
    finalQuestionBenchmarksPayload: any;
    remedialQuestionIds: any;
    draftContentFormData: any;
    goalLevels: any;
    fetchBenchMarkInfo: Function;
}

interface SectionsInContentWithStates {
    inContent: any,
    isPageLoaded: boolean,
    progressBarSetting: any,
    previousEventInContent: any,
    isAuthorDialogOpen: boolean,
    isPublishedDialogOpen: boolean,
    isReviwerDialogOpen: boolean,
    selectedAuthors: any,
    questionId: any,
    draft100Percent: any,
    draftLessThan100Percent: any;
    rePublishContentId: string,
    addToQueueStates: ADD_TO_QUEUE_STATES,
    showTooltip: boolean,
    isAlreadyInAddToQueue: boolean,
    alreadyInAddToQueueMsg: string,
    inSubTypes: any,
    completeCountForSubTypes: any,
    isTemplateChanged: boolean,
    isBenchMarkUpdated: boolean,
    isOpenBenchmarkDialog: boolean,
    reasonRepublishPopup: boolean,
    userSelectedFromAuthors: any,
    republishQueue: string;
    submitToAnotherValidatorClicked: boolean,
    isChallengeRejectionModalOpen: boolean,
    publishDialogBody: string,
    publishDialogHeading: string,
    publishQuestionDirectly: boolean,
    isPublishDirectlyModalOpen: boolean,
    disablePubliushDirectlyButton:  boolean,
}

enum ADD_TO_QUEUE_STATES {
    DEFAULT = 0,
    DIELOG_OPEN,
    DONE
}

class SectionsInContent extends Component<SectionsInContentWithProps, SectionsInContentWithStates>{
    [x: string]: any;
    timerHandler: any = 0;
    updateTimer: any = 0;
    contentRequestCount: any = 0;

    constructor(props: SectionsInContentWithProps, state: SectionsInContentWithStates) {
        super(props);
        this.state = {
            inContent: [],
            isPageLoaded: true,
            progressBarSetting: { barLength: 0, barPercentage: 0 },
            //This will help for setTimeOut
            previousEventInContent: {},
            isAuthorDialogOpen: false,
            isPublishedDialogOpen: false,
            isReviwerDialogOpen: false,
            selectedAuthors: [],
            questionId: "",
            draft100Percent: [],
            draftLessThan100Percent: [],
            rePublishContentId: '',
            addToQueueStates: ADD_TO_QUEUE_STATES.DEFAULT,
            showTooltip: false,
            isAlreadyInAddToQueue: false,
            alreadyInAddToQueueMsg: '',
            inSubTypes: [],
            completeCountForSubTypes: 0,
            isTemplateChanged: false,
            isBenchMarkUpdated: false,
            isOpenBenchmarkDialog: false,
            reasonRepublishPopup: false,
            userSelectedFromAuthors: null,
            republishQueue: '',
            submitToAnotherValidatorClicked: false,
            isChallengeRejectionModalOpen: false,
            publishDialogBody: '',
            publishDialogHeading: '',
            publishQuestionDirectly: false,
            isPublishDirectlyModalOpen: false,
            disablePubliushDirectlyButton: false,
        };

        this.canPublishContent = this.canPublishContent.bind(this);
        this.publishContent = this.publishContent.bind(this);
        this.setReview = this.setReview.bind(this);
        this.togglePublishDialogOpen = this.togglePublishDialogOpen.bind(this);
        this.publishErrorClose = this.publishErrorClose.bind(this);
        this.dialogueDraftQuestionBack = this.dialogueDraftQuestionBack.bind(this);
        this.dialogueCompleteDraftQuestionBack = this.dialogueCompleteDraftQuestionBack.bind(this);
        this.publishErrorRefresh = this.publishErrorRefresh.bind(this);
        this.completeDraftQuestionPublish = this.completeDraftQuestionPublish.bind(this);
        this.beforeAuthorPublishDialogue = this.beforeAuthorPublishDialogue.bind(this);
        this.afterAuthorSelection = this.afterAuthorSelection.bind(this)
        this.handleHover = this.handleHover.bind(this);
        this.checkPreviousKeysTestPaper = this.checkPreviousKeysTestPaper.bind(this);
    }

    componentDidMount() {
        this.generateContentType();
        //FIXME: Remember to uncomment this
        this.timerHandler = setInterval(() => {
            let { previousEventInContent } = this.state;
            if (previousEventInContent) {
                previousEventInContent.keyName = "";
                this.handleValidation(previousEventInContent);
            }
        }, 17000)
        const { fromURL } = this.props;
        const urlParams = new URLSearchParams(fromURL);
        const value = urlParams.get('publishDirectly');
        if(value) {
          this.setState({
            publishQuestionDirectly: true,
            disablePubliushDirectlyButton: true,
          });
        }


    }

    componentDidUpdate(prevProps: any, prevState: any) {
        if (!_.isEqual(this.props.notesSubTypes, prevState.inSubTypes)) {
            this.setState({
                isPageLoaded: true,
            }, () => this.generateContentType());
        }
        if (this._checkForAddToQueueModeActive()) {
            window.onbeforeunload = () => true
        } else {
            //@ts-ignore
            window.onbeforeunload = undefined
        }
    }


    componentWillUnmount() {
        clearInterval(this.timerHandler);
        clearTimeout(this.updateTimer);
    }

    getSectionId = (sectionLabel: string, sectionNo: number) => {
        const { type } = this.props.queryParams;
        let id = _.camelCase(sectionLabel)
        if (type === 'question' && sectionLabel !== 'Add Tags' && sectionLabel !== 'Create Scenario') {
            id += `-${sectionNo}`
        }
        return id;
    }

    onSectionClick = (sectionLabel: string, sectionNo: number) => {
        let id = this.getSectionId(sectionLabel, sectionNo);
        if (id.includes('addBenchmarking')) {
            id = 'addBenchmarking';
        }
        scrollIntoView(id);
    }

    formatDataForParagraphRemedialQuestion = (contentDataList: any) => {
        const { content = [] } = contentDataList || {};
        content.forEach((contentObj: any, index: number) => {
          const remedialKey: string = `remedial${index + 1}`;
          if (this.props.remedialQuestionIds[remedialKey]) {
            contentObj.remedialQuestionIds = this.props.remedialQuestionIds[remedialKey];
          }
        });
      };

    isChildSubSectionFocused = (sectionNo: number, subSectionNo: number | string = '', order?: any) => {
        // if subSectionNo is not empty string then its a subsection
        if (subSectionNo !== '') {
            return false;
        }
        const { focusedSection: { currentlyFocusedSection } } = this.props;
        if (order) {
            return order.toString() === _.get(currentlyFocusedSection.split('-'), '[1]', '');
        } else {
            return false;
        }
    }


    stepLabelType(label: string, type: statusType, sectionNo: number, subSectionNo: number | string = '', order?: any): any {
        const { classes, focusedSection: { currentlyFocusedSection } } = this.props;
        let sectionId = this.getSectionId(label, sectionNo);
        const isCurrentlyEditing = sectionId === currentlyFocusedSection || this.isChildSubSectionFocused(sectionNo, subSectionNo, order);
        return (<StepLabel className={classNames(isCurrentlyEditing && classes.focusedStep)} onClick={() => this.onSectionClick(label, sectionNo)} icon={this.stepLevelIconType(type, sectionNo, subSectionNo, isCurrentlyEditing)}><Typography className={classes.cursorPointer} variant="body1">{label}</Typography></StepLabel>)
    }

    componentWillReceiveProps(nextProps: any) {
        if (this.updateTimer == 0) {
            this.updateTimer = setTimeout(() => {
                this.generateContentType();
                this.updateEvent();
                this.eventParagraph();
                this.updateTimer = 0;
            }, 1000)
        }

        // const {content} = this.props
        // if(nextProps.isTemplateChanged) {

        // }
        // if(nextProps.content.content.ruleId && 
        //     this.props.content.content.ruleId != nextProps.content.content.ruleId) {
        //         this.setState({
        //             isTemplateChanged: true
        //         })
        //         this.props.fetchGoalLevels({params: {courseTypeId: 
        //             content.content.courseId &&
        //             content.content.courseId[0] &&
        //             content.content.courseId[0].courseType &&
        //             content.content.courseId[0].courseType.id
        //           }})
        //     } else {
        //         this.setState({
        //             isTemplateChanged: false
        //         })
        //     }
    }



    eventParagraph() {
        let { paragraphInSection } = this.props;
        let { inContent } = this.state;
        if (!_.isUndefined(_.get(paragraphInSection, "typeOfQuestion"))) {
            if (!_.isUndefined(paragraphInSection.typeOfQuestion)) {
                inContent.forEach((element: any, i: any) => {
                    if (element.title.search("Question") > -1) {
                        element.title = `${paragraphInSection.typeOfQuestion} Question No. ${i}`;
                    }
                });
            }
            this.addParagraphSection(paragraphInSection.typeOfQuestion, paragraphInSection.noOfQuestion);
        }
    }

    dialogueDraftQuestionBack() {
        this.setState({ draft100Percent: [] });
    }

    dialogueCompleteDraftQuestionBack() {
        this.setState({ draftLessThan100Percent: [] });
    }


    addParagraphSection(typeOfQuestion: any, noOfQuestion: any) {
        const {content, isFtre} = this.props;
        const questionSpecialPurposes = (content && content.specialPurposes) || [];
        const isAitsOrNationalLevel = questionSpecialPurposes.includes(CONTENT_SECTION_KEYS.NATIONAL_LEVEL_TEST) || questionSpecialPurposes.includes(CONTENT_SECTION_KEYS.AITS);
        const isGlorifireOrFtre = !isAitsOrNationalLevel;

        let { inContent } = this.state;
        const studentUser = getUserType(USER_TYPE.STUDENT);
        let status: ContentInSection = {};
        //Remove last two index from incontent
        // let lastKey = inContent.splice(-1);
        //Minus 1 since we have 1st key creare scenario 
        let previouL = inContent.length - 1;
        let newC = noOfQuestion - previouL;
        if (newC > 0) {
            for (let i = 0; i < newC; i++) {
                status.title = `${typeOfQuestion} Question No. ${previouL + i + 1}`;
                status.key = " " + previouL + 1;
                status.state = 4;

                let indexSection = (typeOfQuestion === "Integer" ||
                typeOfQuestion === "Numerical" || typeOfQuestion === "Blanks") ? indexOfParagraphInSectionInteger : 
                (typeOfQuestion === 'Descriptive' ? descriptiveSectionKeys : indexOfParagraphInSection);

                status['typeOfQuestion'] = typeOfQuestion;
                
                if(typeOfQuestion === "Matrix") {
                    indexSection = indexOfParagraphInSectionMatrix;
                }

                indexSection.forEach((ob: any, j: any) => {
                    if (ob === "stepWiseSolution" && studentUser) return;
                    if (!status.subType) {
                        status.subType = [];
                    }
                    status.subType.push({ visible: false, title: (typeOfQuestion === "Integer" ||
                    typeOfQuestion === "Numerical" || typeOfQuestion === "Blanks") ? 
                    paragraphInnerHeaderInteger[j] : (typeOfQuestion === 'Descriptive' ?
                    descriptiveHeaderSideTitles[j] :  paragraphInnerHeader[j]), state: 4, key: ob })
                    if (this.props.isFtre || studentUser) {
                        if ((status.subType.slice(-1)[0] || {}).key === 'addDifficultyAndSkills') {
                            status.subType.pop();
                        }
                    }
                    if (isGlorifireOrFtre) {
                        if ((status.subType.slice(-1)[0] || {}).key === 'addBenchmarking') {
                            status.subType.pop();
                        }
                    }
                });
                inContent.push(status);
                status = {};
            }
        }
        else if (_.isNumber(noOfQuestion)) {
            inContent.splice(noOfQuestion + 1, previouL)
        }
        inContent = [...inContent];
        this.setState({
            inContent: inContent
        })
    }

    addToQueueCancel = () => {
        this.setState({
            addToQueueStates: ADD_TO_QUEUE_STATES.DEFAULT,
            isAlreadyInAddToQueue: false
        })
    }
    closeRepublishDialog() {
        this.setState({
            reasonRepublishPopup: false,
            republishQueue: ''
        })
    }
    rePublish() {
        this.publishContent(this.state.userSelectedFromAuthors)
    }

    handleRepublishQueueChange(event: any) {
        const { value } = event.target;
        this.setState({
            republishQueue: value
        })
    }
    updateEvent() {
        let { inContent, previousEventInContent } = this.state;
        let { eventInContent } = this.props;
        previousEventInContent = eventInContent;

        if (_.get(eventInContent, "keyName", "") != "") {
            if (eventInContent.j != "paragraph") {
                inContent.forEach((element: any) => {
                    if (element.key == eventInContent.keyName) {
                        element.previousState = element.state;
                        element.state = eventInContent.state;
                    }
                });
            }
            else {
                inContent.forEach((ob: any, i: any) => {
                    //For outer element
                    ob.order = i;
                    if (ob.key == eventInContent.keyName) {
                    }
                    //Since question start's from 1 index 
                    else if ((i === eventInContent.i + 1)) {
                        if (ob.subType) {
                            ob.visible = true;
                            ob.subType.forEach((a: any, b: any) => {
                                if (a.key == eventInContent.keyName) {
                                }
                                a.visible = true;
                            });
                        }
                    }
                    else {
                        //type check so that for outer element it should now go inside subsection i.e for create scenerio
                        if (typeof eventInContent.i == "number" && ob.subType) {
                            ob.visible = false;
                            ob.subType.forEach((t: any, k: any) => {
                                t.visible = false;
                            });
                        }


                    }
                });
            }
            this.setState({
                inContent: inContent,
                previousEventInContent: previousEventInContent
            })

            this.handleValidation(eventInContent);
        }
    }

    handleValidation(eventInContent: any) {
        let { subType, type } = this.props.queryParams;
        const { formData } = this.props;
        const { createdAt, updatedAt } = formData;
        const forceAllValidations = createdAt !== updatedAt;
        let key = `${subType}_${type}`;
        if (type == 'testpapers') {
            key = `${type}`;
        }
        switch (key) {
            case '5_question': {
             
                this.paragraphValidation(eventInContent.keyName, eventInContent.i);
                break;
            }
            //Study notes
            case 'notes_studymaterial':
            case 'formulas_studymaterial':
            case 'videos_studymaterial':
            case 'audios_studymaterial':
            case 'sampleproblem_studymaterial':
                this.studyMaterialValidation(eventInContent.keyName);
                break;
            case 'testpapers':
                this.testPapersValidation(eventInContent.keyName, forceAllValidations);
                break;
        }
    }

    currentTypeOfQuestion = null;
    descriptiveValidation: any = { 'collectiveBooleanFeedback': false };

    paragraphValidation(keyName: string, indexUsed: any) {

        let { inContent } = this.state;
        const { tagsList, formData, formDataError } = this.props;

        let typeOfQuestion = null;

        let progress = JSON.parse(JSON.stringify(formData));
        const studentUser = getUserType(USER_TYPE.STUDENT);
        let k: any = [];
        k = inContent.filter((o: any) => o.key == 'tags');

        for (let i = 0; i < (inContent || []).length; i++) {
            if ('typeOfQuestion' in inContent[i]) {
                typeOfQuestion = inContent[i].typeOfQuestion;
                this.currentTypeOfQuestion = inContent[i].typeOfQuestion;
                break;
            }
        }

        if (k && k.length > 0 && progress.tags && progress.tags.length != 0) {
            let requiredCount = 0;
            let requiredMeet = 0;
            tagsList.forEach(t => {
                if (t.isCompulsory) {
                    requiredCount++;
                    if (progress.tags && progress.tags.length > 0) {
                        progress.tags.forEach((pt: any) => {
                            if (pt.relation && pt.relation.id && t._id == pt.relation.id) {
                                if (pt.values && pt.values[0]) {
                                    requiredMeet++;
                                }
                            }
                        })
                    }
                }
            });
            k[0]["state"] = requiredCount != requiredMeet ? statusType.warning : statusType.success;


            formDataError['tags'] = { error: false, errorText: "" };
            if (requiredCount != requiredMeet) {
                formDataError['tags'] = { error: true, errorText: "All mandatory tags must be entered." };
            }
        }

        for (let index = 0; index < progress.content.length; index++) {
            let content = progress.content && progress.content.length > 0 ? progress.content[index] : {};

            //create index
            if (!formDataError["questions"][index]) {
                formDataError["questions"][index] = {};
            }
            k = inContent.filter((o: any) => o.key == 'passageQuestion');

            //This condition helps to keep field in edit mode when user type in other field at that time this will update status
            if (content && k && k.length > 0 && keyName != "passageQuestion") {
                k[0]["state"] = (content.passageQuestion && content.passageQuestion.length > 0 && content.typeOfQuestion && formData.totalQuestion) ? statusType.success : statusType.warning;
                //show error
                formDataError['content'] = { error: false, errorText: "" };
                if (!(content.passageQuestion)) {
                    formDataError['content'] = { error: true, errorText: "Content must be entered." };
                } else if (!(content.passageQuestion && content.passageQuestion.length > 0)) {
                    formDataError['content'] = { error: true, errorText: "Content length should not be less than 5 character." };
                }
               
            }


            //Since question subtree start will strat from 1 
            if (!_.isEmpty(content) && content.questionContent && formDataError["questions"][index]) {
                k = [];
                k = inContent[index + 1];
                k = k ? k.subType.filter((o: any) => o.key == 'questionContent') : [];
                //This condition helps to keep feild in edit mode when user type in other field at that time this will update status
                // 
                if (k && k.length > 0 && keyName != "questionContent") {
                    k[0]["state"] = content.questionContent.length > 0 ? statusType.success : statusType.warning;

                    //show error
                    formDataError["questions"][index]['content'] = { error: false, errorText: "" };
                    if (!(content.questionContent)) {
                        formDataError["questions"][index]['content'] = { error: true, errorText: "Content must be entered." };
                    } else if (!(content.questionContent && content.questionContent.length > 0)) {
                        formDataError["questions"][index]['content'] = { error: true, errorText: "Content length should not be less than 5 character." };
                    }
                }
            }

            if (!_.isEmpty(content) && (content.difficultyLevel || content.difficultyType) && formDataError["questions"][index]) {
                k = [];
                k = inContent[index + 1];
                k = k ? k.subType.filter((o: any) => o.key == 'addDifficultyAndSkills') : [];
                if (k && k.length > 0 && keyName != 'addDifficultyAndSkills') {
                    k[0]["state"] = (content.difficultyLevel.length && content.difficultyType.length) ? statusType.success : statusType.warning;

                    formDataError["questions"][index]['addDifficultyAndSkills'] = { error: false, errorText: "" };
                    if (content.difficultyLevel.length && content.difficultyType.length) {
                        formDataError["questions"][index]['addDifficultyAndSkills'] = { error: true, errorText: 'Difficulty level and skill should be added' };
                    }
                }
            }

            if (!_.isEmpty(content) && content.benchmarks && formDataError["questions"][index]) {
                k = [];
                k = inContent[index + 1];
                k = k ? k.subType.filter((o: any) => o.key == 'addBenchmarking') : [];
                if (k && k.length > 0 && keyName != 'addBenchmarking') {
                    formDataError["questions"][index]['addBenchmarking'] = { error: false, errorText: "" };
                    k[0]["state"]= statusType.success;
                    (content.benchmarks || []).forEach((benchmark: any) => {
                        const { course, goalLevel, isDeleted } = benchmark;
                        const isValidBenchMark = course.id && goalLevel.id;
                        if (!isValidBenchMark && !isDeleted) {
                            k[0]["state"]= statusType.warning;
                            formDataError["questions"][index]['addBenchmarking'] = { error: true, errorText: 'Benchmark should be added' };
                        }
                    });
                }
            }

            if (!_.isEmpty(content) && content.optionsContent && formDataError["questions"][index]) {
                k = [];
                k = inContent[index + 1];
                k = k ? k.subType && k.subType.filter((o: any) => o.key == 'optionsContent') : [];
                if (k && k.length > 0) {
                    if (keyName != "optionsContent") {
                        let c = content.optionsContent.map((o: any) => (o.value).trim());
                        // status["optionsContent"] = oP.includes('') ? '3' : '1';
                        k[0]["state"] = c.length < 2 || c.includes('') ? statusType.warning : statusType.success;
                        //show error
                        formDataError["questions"][index]['optionsContent'] = { error: false, errorText: "" };
                        if (c.length < 2) {
                            formDataError["questions"][index]['optionsContent'] = { error: true, errorText: "Atleast two Options must be entered." };
                        } else if (c.includes('')) {
                            formDataError["questions"][index]['optionsContent'] = { error: true, errorText: "Options can not be blank." };
                        }
                    }
                }
            }
            if (!_.isEmpty(content) && !_.isEmpty(content.matrixOptionContent) && formDataError["questions"][index]) {
                k = [];
                k = inContent[index + 1];
                k = k ? k.subType && k.subType.filter((o: any) => o.key == 'matrixOptionContent') : [];
                if (k && k.length > 0) {
                    if (keyName != "matrixOptionContent") {
                        let statusUpdate = true;

                        // let c = content.matrixOptionContent.map((o: any) => (o.value).trim());
                        const { optionLeft, optionRight } = content.matrixOptionContent;
                        optionLeft.forEach((o: any) => {
                          if (o.value.trim().length <= 0 || emptyLatexValue.includes(o.value)) {
                            statusUpdate = false;
                          }
                        });
                        optionRight.forEach((o: any) => {
                          if (o.value.trim().length <= 0 || emptyLatexValue.includes(o.value)) {
                            statusUpdate = false;
                          }
                        });
                        k[0]["state"] = !statusUpdate ? statusType.warning : statusType.success;
                        //show error
                        if (!statusUpdate) {
                            formDataError["questions"][index]['matrixOptionContent'] = { error: true, errorText: "Options can not be blank." };
                        } else {
                            formDataError["questions"][index]['matrixOptionContent'] = { error: false, errorText: "" };

                        }
                    }
                }
            }
            if (!_.isEmpty(content) && _.get(content, 'matrixOptionContent.optionLeft.length', 0) > 0 && content.correctAnswer && formDataError["questions"][index]) {
                k = [];
                let b: any = {};
                b = inContent[index + 1];
                k = b ? b.subType && b.subType.filter((o: any) => o.key == 'correctAnswer') : [];
                if (k && k.length > 0) {

                    if (keyName != "correctAnswer") {
                        const { optionLeft } = content.matrixOptionContent;
                        if (typeOfQuestion !== "Blanks") {

                            k[0]["state"] = content.correctAnswer && content.correctAnswer.data && content.correctAnswer.data.length === optionLeft.length ? statusType.success : statusType.warning;

                            //show error
                            if (k[0]["state"] === statusType.success) {
                                formDataError["questions"][index]['correctAnswer'] = { error: false, errorText: "" };

                            } else {
                                formDataError["questions"][index]['correctAnswer'] = { error: true, errorText: "All Answers must be entered." };

                            }
                        }
                        if (typeOfQuestion === "Blanks") {
                            if (content.correctAnswer.data && content.correctAnswer.length >= 1 && content.correctAnswer[0].value.length) {
                                k[0]["state"] = statusType.success
                            } else {
                                k[0]["state"] = statusType.warning
                            }
                        }

                    }
                }
            }

            if (!_.isEmpty(content) && _.get(content, 'matrixOptionContent.optionLeft.length', 0) === 0 &&  content.correctAnswer && formDataError["questions"][index]) {
                k = [];
                let b: any = {};
                b = inContent[index + 1];
                k = b ? b.subType && b.subType.filter((o: any) => o.key == 'correctAnswer') : [];
                if (k && k.length > 0) {
                    if (keyName != "correctAnswer") {
                        k[0]["state"] = content.correctAnswer && content.correctAnswer.data && content.correctAnswer.data.length > 0 ? statusType.success : statusType.warning;
                        if (content.typeOfQuestion === "3") {
                            if (typeOfQuestion !== "Blanks") {
                                if (content.correctAnswer && content.correctAnswer.data && content.correctAnswer.data.length >= 1 && !_.isUndefined(content.correctAnswer.data[0].weightage) && _.get(content, 'correctAnswer.data[0].weightage', '') !== '') {
                                    k[0]["state"] = statusType.success
                                } else {
                                    k[0]["state"] = statusType.warning
                                }
                            }
                        }
                        //condition for mmcq atleast two should be selected
                        if (k.subType == 8 && k[0]["state"] == statusType.success) {

                            k[0]["state"] = (content.correctAnswer.data.length >= 2 ? statusType.success : statusType.warning);

                        }
                        if (typeOfQuestion === "Blanks") {
                            if (content.correctAnswer && (content.correctAnswer.data ? (content.correctAnswer.data.length && content.correctAnswer.data[0].value && content.correctAnswer.data[0].value.length) : (content.correctAnswer.length && content.correctAnswer[0].value.length))) {
                                k[0]["state"] = statusType.success
                            } else {
                                k[0]["state"] = statusType.warning
                            }
                        }

                        //show error
                        formDataError["questions"][index]['correctAnswer'] = { error: false, errorText: "" };
                        if (k.subType != 8 && k[0]["state"] == statusType.warning && (_.get(content, 'typeOfQuestion', 0) === "4")) {
                            formDataError["questions"][index]['correctAnswer'] = { error: false, errorText: "" };
                        } else if (k.subType == 8 && k[0]["state"] == statusType.warning) {
                            if (content.correctAnswer.data.length >= 2) {
                                formDataError["questions"][index]['correctAnswer'] = { error: true, errorText: "Atleast two Answers must be entered." };
                            }
                        }
                    }
                }
            }



            if (!_.isEmpty(content) && content.stepWiseSolution && formDataError["questions"][index]) {
                k = [];
                k = inContent[index + 1];
                k = k && k.subType ? k.subType.filter((o: any) => o.key == 'stepWiseSolution') : [];
                if (k && k.length > 0) {
                    if (keyName != "stepWiseSolution") {
                        const validationResults = { solutions: { status: statusType.success, type: 'step', isEmptyWeightage: false } };
                        validateStepWiseSolutions(validationResults, content.stepWiseSolution);

                        // k[0]["state"] = !validationResults.solutions.error ? statusType.success : statusType.warning;

                        if (validationResults.solutions.status === statusType.warning) {
                            k[0]["state"] = statusType.warning;
                            if (validationResults.solutions.type === 'step') {
                                formDataError["questions"][index]['stepWiseSolution'] = { error: true, errorText: "Steps cannot be blank." };
                            }
                        } else {
                            k[0]["state"] = statusType.success;
                            formDataError["questions"][index]['stepWiseSolution'] = { error: false, errorText: "" };
                        }

                        // k[0]["state"] = content.solutionContent && content.solutionContent.length > 0 ? statusType.success : statusType.warning;


                        // formDataError["questions"][index]['solutionContent'] = { error: false, errorText: "" };
                        // if (!content.solutionContent) {
                        //     formDataError["questions"][index]['solutionContent'] = { error: true, errorText: "Solution must be entered in question." };
                        // }
                        // if (!(content.solutionContent && content.solutionContent.length > 0)) {
                        //     formDataError["questions"][index]['solutionContent'] = { error: true, errorText: "Solution length should be more than 0 character." };
                        // }
                    }
                }
            }
            if (!_.isEmpty(content) && content.subjects && formDataError["questions"][index]) {
                k = [];
                k = inContent[index + 1];
                k = k ? k.subType && k.subType.filter((o: any) => o.key == 'subjects') : [];
                if (k && k.length > 0) {
                    if (keyName != "subjects") {
                        k[0]["state"] = _.isEmpty(content.subjects) ? statusType.warning : statusType.success;
                        formDataError["questions"][index]['subjects'] = { error: false, errorText: "" };
                        if (_.isEmpty(content.subjects)) {
                            formDataError["questions"][index]['subjects'] = { error: true, errorText: studentUser ? 'Question must be mapped to a subject.' : 'Atleast one concept must be mapped.' };
                        }
                    }
                }
            }
        }
        this.calCulateProgressBar();
        this.checkPreviousKeys(inContent);
        // this.setState({
        //     inContent: inContent
        // });
    }

    studyMaterialValidation(keyName: string) {
        let { inContent } = this.state;
        const { formData, tagsList } = this.props;
        let { formDataError } = this.props;
        let progress = formData;
        let content = progress.content && progress.content.length > 0 ? progress.content[0] : {};
        const studentUser = getUserType(USER_TYPE.STUDENT);

        if (!['studyNotes'].includes(keyName)) {
            if (content["content"] || content["title"]) {
                let k = inContent.filter((o: any) => ['sampleProblem', 'studyNotes'].includes(o.key));
                if (k && k.length > 0) {
                    let status = statusType.warning;
                    if (content["content"] || content["createQuestion"] || content["createContent"] || content["title"]) {
                        status = (content.content || content.createQuestion || content.createContent) && content.title && ((content.createQuestion && content.createQuestion.length > 1) || (content.createContent && content.createContent.length > 1) || (content.content && content.content.length > 1)) && content.title.length > 1 ? statusType.success : statusType.warning;

                        k[0]["state"] = status;
                        this.checkPreviousKeyStudyMaterial(0);


                        //show error
                        formDataError['title'] = { error: false, errorText: "" };
                        formDataError['content'] = { error: false, errorText: "" };
                        if (!(content.title)) {
                            formDataError['title'] = { error: true, errorText: "Title must be entered." };
                        } else if (!(content.title && content.title.length > 1)) {
                            formDataError['title'] = { error: true, errorText: "Title length should not be less than 1 character." };
                        }
                        if (!(content.content)) {
                            formDataError['content'] = { error: true, errorText: "Content must be entered." };
                        } else if (!(content.content && content.content.length > 1)) {
                            formDataError['content'] = { error: true, errorText: "Content length should not be less than 1 character." };
                        }

                    }
                }
            }
        }

        if (!['formula'].includes(keyName)) {
            if (content["content"] || content["title"] || content['derivation']) {
                let k = inContent.filter((o: any) => o.key == 'formula');
                if (k && k.length > 0) {
                    let status = statusType.warning;
                    if (content["content"] || content["title"] || content['derivation']) {
                        //content.derivation && && content.derivation.trim().length > 10
                        status = content.content && content.title && content.content.length > 1 && content.title.length > 1 ? statusType.success : statusType.warning;
                    }
                    k[0]["state"] = status;
                    this.checkPreviousKeyStudyMaterial(0);



                    //show error
                    formDataError['title'] = { error: false, errorText: "" };
                    formDataError['content'] = { error: false, errorText: "" };
                    if (!(content.title)) {
                        formDataError['title'] = { error: true, errorText: "Title must be entered." };
                    } else if (!(content.title && content.title.length > 1)) {
                        formDataError['title'] = { error: true, errorText: "Title length should not be less than 1 character." };
                    }
                    if (!(content.content)) {
                        formDataError['content'] = { error: true, errorText: "Content must be entered." };
                    } else if (!(content.content && content.content.length > 1)) {
                        formDataError['content'] = { error: true, errorText: "Content length should not be less than 1 character." };
                    }
                }
            }
        }

        if (progress && progress.subjects) {
            let k: any = [];
            k = inContent.filter((o: any) => o.key == 'subjects');
            if (k && k.length > 0) {
                if (!["studyNotes", "formula", ""].includes(keyName)) {
                    let v = progress.subjects && progress.subjects.length > 0 ? 1 : "";
                    k[0]["state"] = v ? statusType.success : statusType.warning;


                    formDataError['subjects'] = { error: false, errorText: "" };
                    if (!v) {
                        formDataError['subjects'] = { error: true, errorText: studentUser ? 'Question must be mapped to a subject.' : 'Atleast one concept must be mapped.' };
                    }


                    this.checkPreviousKeyStudyMaterial(1);
                }

            }
        }

        if (progress.tags && progress.tags.length > 0) {
            let k: any = [];
            k = inContent.filter((o: any) => o.key == 'tags');
            if (k && k.length > 0) {
                if (keyName != "tags") {
                    let requiredCount = 0;
                    let requiredMeet = 0;
                    tagsList.forEach(t => {
                        if (t.isCompulsory) {
                            requiredCount++;
                            if (progress.tags && progress.tags.length > 0) {
                                progress.tags.forEach((pt: any) => {
                                    if (pt.relation && pt.relation.id && t._id == pt.relation.id) {
                                        if (pt.values && pt.values[0]) {
                                            requiredMeet++;
                                        }
                                    }
                                })
                            }
                        }
                    });
                    k[0]["state"] = requiredCount !== requiredMeet ? statusType.warning : statusType.success;


                    formDataError['tags'] = { error: false, errorText: "" };
                    if (requiredCount != requiredMeet) {
                        formDataError['tags'] = { error: true, errorText: "All mandatory tags must be entered." };
                    }
                }
                this.checkPreviousKeyStudyMaterial(2);
            }
        }

        this.setState({
            inContent: inContent
        });

        this.props.changeFormDataError(formDataError);
    }

    checkPreviousKeyStudyMaterial(atIndex: any) {
        let { inContent } = this.state;
        let { formData } = this.props;
        let progress = formData;
        let content = progress.content && progress.content.length > 0 ? progress.content[0] : {};
        inContent.forEach((ob: any, i: any) => {
            if (atIndex >= i) {
                //Since studyNotes has inner child for specific key
                //Notes condition
                if (['sampleProblem', 'studyNotes'].includes(ob.key)) {
                    if (!content['title'] && !content['content']) {
                        ob.state = statusType.warning;
                    }
                }
                //Notes condition end                

                //Formula condition
                else if (ob.key == 'formula') {
                    if (!content["content"] && !content["title"] && !content['derivation']) {
                        ob.state = statusType.warning;
                    }
                }
                //Formula condition


                else if (!['tags', 'subjects'].includes(ob.key)) {
                    if (!content[ob.key]) {
                        ob.state = statusType.warning;
                    }
                }
                else if (!progress[ob.key]) {
                    ob.state = statusType.warning;
                }
            }
        })
        this.calCulateProgressBar();
    }

    testPapersValidation(keyName: string, forceAllValidations?: boolean) {
        let { inContent } = this.state;
        let { formDataError, sectionCurrentlyEditing = '' } = this.props;
        let progress = JSON.parse(JSON.stringify(this.props.formData));
        let k: any = [];
        let content = progress.content && progress.content.length > 0 ? progress.content[0] : {};

        if (forceAllValidations || ['basicInfo'].includes(sectionCurrentlyEditing)) {
            if (progress["name"] || progress["courseId"]) {
                k = [];
                k = inContent.filter((o: any) => o.key == 'basicInfo');
                if (k && k.length > 0) {
                    let status = statusType.warning;
                    status = progress.name && progress.groupId && progress.name.length > 5 ? statusType.success : statusType.warning;
                    k[0]["state"] = status;

                    //show error
                    formDataError['title'] = { error: false, errorText: "" };
                    if (!(progress.name)) {
                        formDataError['title'] = { error: true, errorText: "Test Name must be entered." };
                    } else if (!(progress.name && progress.name.length >= 5)) {
                        formDataError['title'] = { error: true, errorText: "Test Name length should not be less than 5 character." };
                    }
                    //show error
                    formDataError['content'] = { error: false, errorText: "" };
                    if (!(progress.groupId)) {
                        formDataError['content'] = { error: true, errorText: "Please select goal." };
                    }
                }
            }
        }

        if (forceAllValidations || ['testFormat'].includes(sectionCurrentlyEditing)) {
            let k = inContent.filter((o: any) => o.key == 'testFormat');
            if (k && k.length > 0) {
                let status = progress.ruleId && progress.ruleId.length > 0 ? statusType.success : statusType.warning;
                k[0]["state"] = status;
                this.checkPreviousKeysTestPaper(2);
            }
        }


        if (forceAllValidations || ['testQuestions'].includes(sectionCurrentlyEditing)) {

            if (progress["ruleId"]) {
                k = [];
                k = inContent.filter((o: any) => o.key == 'testQuestions');
                if (k && k.length > 0) {
                    if (progress['data'] && progress['data']['sections'] && progress['data']['sections'].length > 0) {

                        let numberOfQuestion = progress.data.questionsCount;
                        let presentCount = 0;
                        progress.data.sections.map((b: any) => { b.subSection.map((a: any) => { if (a.questions) presentCount += a.questions.length; }) });
                        k[0]["state"] = numberOfQuestion == presentCount ? statusType.success : statusType.warning;
                        this.checkPreviousKeysTestPaper(1);
                    }
                    else {
                        k[0]["state"] = statusType.warning;
                        this.checkPreviousKeysTestPaper(3);
                    }
                }
            }
        }
        if (this.props.testSubjects && this.props.testSubjects.length > 0) {
            let k: any = [];
            k = inContent.filter((o: any) => o.key == 'subjects');
            if (k && k.length > 0) {
                k[0]["state"] = this.props.testSubjects && this.props.testSubjects.length > 0 ? statusType.success : statusType.warning;
                this.checkPreviousKeysTestPaper(0);
            }
        } else {
            this.checkPreviousKeysTestPaper(1);
        }
        this.setState({
            inContent: inContent
        });

        this.props.changeFormDataError(formDataError);
    }

    //This will help to check whether previous feild value is present from current feild
    checkPreviousKeys(inContent: any) {
        //let { inContent } = this.state;
        //Will be used for inner section if error found inside inner section show error at parent level also
        // let isError: any; 
        inContent.forEach((ob: any, i: any) => {
            if (ob.subType && ob.subType.length > 0) {
                let isV = ob.subType.map((q: any) => q.state);
                ob.state = isV && isV.every((o: any) => o == statusType.success) ? statusType.success : statusType.warning;
            }

        });
        this.setState({
            inContent: inContent
        }, () => { this.calCulateProgressBar() });
    }

    checkPreviousKeysTestPaper(atIndex: any) {
        let { inContent } = this.state;
        let { formData } = this.props;
        let progress = formData;
        let content = progress.content && progress.content.length > 0 ? progress.content[0] : {};
        inContent.forEach((ob: any, i: any) => {
            if (atIndex >= i) {
                //basic condition
                if (ob.key == 'basicInfo') {
                    if ((_.isEmpty(progress["name"]) || _.isUndefined(progress["name"])) && _.isEmpty(progress["goal"])) {
                        ob.state = statusType.warning;
                    }
                }
                else if (ob.key == 'subjects') {
                    ob.state = progress.subjects && progress.subjects.length > 0 ? statusType.success : statusType.warning;
                }
                else if (ob.key == 'testFormat') {
                    if (_.isEmpty(progress["ruleId"]) || _.isUndefined(progress["ruleId"])) {
                        ob.state = statusType.warning;
                    }
                }
                //Formula condition
                else if (['testQuestions'].includes(ob.key)) {
                    if (!progress['data'] || !progress['data']['sections']) {
                        ob.state = statusType.warning;
                    }
                }

            }
        })
        this.calCulateProgressBar();
    }

    calCulateProgressBar() {
        let { progressBarSetting, inContent } = this.state;
        progressBarSetting.barLength = 0;
        progressBarSetting.barPercentage = 0;
        let numberOfSections = inContent && inContent.length;
        let eachSectionsPoints = 100 / numberOfSections;
        inContent.forEach((ob: any, i: any) => {

            let obj = {
                isDescriptive: this.currentTypeOfQuestion === 'Descriptive',
                collectiveBooleanFeedback: this.descriptiveValidation['collectiveBooleanFeedback'],
                'ob.typeOfQuestion is descriptive': ob.typeOfQuestion === 'Descriptive',
                currentCollectiveBooleanFeedback: (this.descriptiveValidation[i + 1] || {})['collectiveBooleanFeedback']
            }

            if ((([statusType.success].includes(ob.state) || [statusType.success].includes(ob.previousState)) && ob.state != statusType.warning)
            ) {
                progressBarSetting.barLength += eachSectionsPoints;
                //@ts-ignore
                progressBarSetting.barPercentage = Math.max(Math.ceil(progressBarSetting.barLength));
                (progressBarSetting.barPercentage > 100) && (progressBarSetting.barPercentage = 100);
            }
        });

        let progressBarState = Object.keys(this.props.formData || {}).length ? progressBarSetting : { barLength: 0, barPercentage: 0 };
        this.setState({
            progressBarSetting: progressBarState
        });
        this.props.completionPercent(this.props.formData, progressBarSetting.barLength);
    }

    generateContentType() {
        if (this.state.isPageLoaded) {
            
            let contentInSection: ContentInSection[] = [];
            let status: ContentInSection = {};
            let res: any = this.getHeaderForSection();
            let { subType, type } = this.props.queryParams;
            if (res) {
                res.header.forEach((element: any, i: number) => {
                    status.title = element;
                    status.key = res.keys[i];
                    
                    status.state = 4;
                    status.visible = true;
                    //this will help to calculate percentage on edit stage
                    status.previousState = 4;
                    // )
                    //Minus 2 since we don't want tags and concept code to be included from last index
                    if (res.isNested && i != 0 && (i < res.header.length - 1) &&
                        `${subType}_${type}` !== 'notes_studymaterial' && `${subType}_${type}` !== 'videos_studymaterial' && `${subType}_${type}` !== 'audios_studymaterial'
                    ) {
                        indexOfParagraphInSection.forEach((ob: any, j: any) => {
                            if (!status.subType)
                                status.subType = [];
                            status.subType.push({ visible: i == 1 ? true : false, title: paragraphInnerHeader[j], state: 4, key: ob, previousState: 4 });
                        });
                    }
                    contentInSection.push(status);
                    status = {};
                });
                const newArrayForTest = [...this.props.notesSubTypes]
                this.setState({
                    inContent: contentInSection,
                    isPageLoaded: false,
                    inSubTypes: newArrayForTest,

                })
            }
        } else {
            let { formData } = this.props;
            let { inContent } = this.state;
            let { type } = this.props.queryParams;

            //Ignoring create scenerio map  Syllabus and add tags
            let count = inContent.length - 3;
            if (formData && formData._id && formData.content && formData.content.length != count) {
                // count = 0;
                let title = this.findTypeOfSubQuestions()
                if (formData && formData.content && formData.content.length >= 2) {
                    this.addParagraphSection(title, formData.content.length);
                    for (let i = 0; i < formData.content.length; i++) {
                        this.handleValidation({ keyName: "", i: i });
                    }
                } else {
                    this.handleValidation({ keyName: "" });
                }
            } else if (type == 'testpapers') {
                this.handleValidation({ keyName: "" });
            }
        }
    }

    findTypeOfSubQuestions = () => {
        const content = _.get(this.props, 'formData.content', []);
        const rootNode = content.find(({ isParagraphRootNode }: any) => isParagraphRootNode);
        if(rootNode) {
            return QUESTION_TYPE[rootNode.typeOfQuestion] || '';
        }
        return '';
    }

    getHeaderForSection() {
        let { subType, type } = this.props.queryParams;
        let { formData } = this.props;

        switch (`${subType}_${type}`) {
            //Question
            case '1_question':
                return { header: commonHeader, keys: matrixSection };
            case '2_question':
            case '0_question':
            case '8_question': {
                return { header: commonHeader, keys: indexOfCommonSection };
            }
            case '5_question':
                return { header: paragraphHeader, keys: paragraphSection, isNested: true }
            case '3_question':
            case '6_question':
            case '7_question': {
                return { header: integerHeader, keys: integerSection };
            }
            case '4_question':
                return { header: descriptiveHeaderSideTitles, keys: descriptiveSection };



            //Study material
            case 'notes_studymaterial':
                return { header: notesMaterial.map(o => o.title), keys: notesMaterial.map(o => o.key), isNested: true }

            case 'audios_studymaterial':
                return { header: audioDetailsMaterial.map(o => o.title), keys: audioDetailsMaterial.map(o => o.key), isNested: true }

            case 'videos_studymaterial':
                return { header: videoDetailsMaterial.map(o => o.title), keys: videoDetailsMaterial.map(o => o.key), isNested: true }
            case 'sampleproblem_studymaterial':
                return { header: sampleProblem.map(o => o.title), keys: sampleProblem.map(o => o.key) }
            case 'formulas_studymaterial':
                return { header: formulaMaterial.map(o => o.title), keys: formulaMaterial.map(o => o.key) }


            // case /^.*testpapers.*$/.test(`${subType}_${type}`):
            case 'full_testpapers':
            case 'chap_testpapers':
            case 'concept_testpapers':
            case 'sample_testpapers':
            case 'part_testpapers':
            case 'practice_testpapers':
            case 'combined_testpapers':
                return { header: testPaper.map(o => o.title), keys: testPaper.map(o => o.key) }
            default:
                return { header: testPaper.map(o => o.title), keys: testPaper.map(o => o.key) }

        }
    }

    stepLevelIconType(type: statusType, sectionNo: number, subSectionNo: number | string, isCurrentlyEditing: boolean) {
        let { classes } = this.props;
        let toShow = (sectionNo + 1).toString();
        if (subSectionNo !== '') {
            toShow = (parseInt(subSectionNo.toString()) + 1).toString()
        }
        if (isCurrentlyEditing) {
            return (<EditOutlinedIcon className={`${classes.icon} ${classes.primaryColor}`} />)
        }
        switch (type) {
            case statusType.success:
                return (<Check className={`${classes.icon} ${classes.successIcon}`} />)
            default:
                return (<StepLabel><Typography className={classes.numberLabel} variant="body1">{toShow}</Typography></StepLabel>)
        }
    }

    async canPublishContent(e: any) {
        e.preventDefault();
        let { progressBarSetting } = this.state;
        let { content, formData } = this.props;
        if (formData.status == 'PUBLISHED' && !formData.draftId) {
            return
        }
        if (progressBarSetting.barPercentage >= 100) {
            if (this.props.queryParams.type === "testpapers") {
                const { draft100Percent, draftLessThan100Percent } = getQuestionsFromFormData(this.props.formData)
                this.setState({ draft100Percent, draftLessThan100Percent }, async () => {
                    const { updatedDraftLessThan100Percent, updatedDraft100Percent } = await this.publishErrorRefresh()
                    if (updatedDraftLessThan100Percent.length === 0
                        && updatedDraft100Percent.length === 0) {
                        this.beforeAuthorPublishDialogue();
                    }
                });
            } else {
                this.beforeAuthorPublishDialogue();
                this.afterAuthorSelection(true, [this.props.authenticatedUser.id])
            }
        }
        else {
            return false;
        }
    }

    addToQueue(usersSelected: any, override?: boolean) {
        const {
            defaultCorrectAnswersForParagraph,
            originalFormData,
            content
        } = this.props;
        let { difficultyLevel,difficultyType, subjects, secondarySubjects } = content.content
        let { formData } = this.props;
        let alternateAnswer = false;
        let paragraphIndex = [];
        for (let i = 0; i < formData.content.length; i++) {
            if (formData.content[i].alternateAnswer) {
                alternateAnswer = true
                break
            }
        }
        const correctAnswerForParagraph: any = formData.content.map((content: any) => {
            content = JSON.parse(JSON.stringify(content))
            delete content.correctAnswer._id
            return content.correctAnswer
        })
        let { subType, type } = this.props.queryParams;
        // const { selectedAuthors } = this.state;
        // const progressBarSetting = calCulateProgressBar(this.props.validations);
        if (type == "studymaterial" && subType != "notes") {
            type = subType;
        }
        // let authors = [...selectedAuthors, usersSelected]
        formData.authors = usersSelected
        formData.completionPercent = 100
        formData.type = "QUESTION"
        if (override) {
            formData.addToQueueOverride = true
        }
        let typeOfQuestion: any = null
        let subjectList: any = []
        let conceptId: any[] = [];
        let conceptCodes: any[] = [];
        if (formData.content && formData.content.length > 0) {
            formData.content.forEach((content: any, eleIndex:number) => {
                if( formData.content[eleIndex].alternateAnswer ){
                    formData.content[eleIndex].optionChange = false;
                }
                else{
                    formData.content[eleIndex].optionChange = !checkIsCorrectAnswerChangeParagraph(defaultCorrectAnswersForParagraph, correctAnswerForParagraph);
                }
                let { difficultyLevel, difficultyType, subjects, secondarySubjects } = formData.content[eleIndex];
                const originalDifficultyLevel=originalFormData.content[eleIndex].difficultyLevel;
                const originalDifficultyType=originalFormData.content[eleIndex].difficultyType;
                const originalSubjects=originalFormData.content[eleIndex].subjects;
                const originalSecondarySubjects=originalFormData.content[eleIndex].secondarySubjects;    
                formData.content[eleIndex].conceptChange = isConceptAndChapterAddToQueueModeActive({
                    subjects,
                    secondarySubjects,
                    originalSubjects,
                    originalSecondarySubjects
                })
                formData.content[eleIndex].difficultySkillLevelChange = isDifficultyAndSkillAddToQueueModeActive({
                    difficultyLevel,
                    difficultyType,
                    originalDifficultyLevel,
                    originalDifficultyType
                })
            })
            formData.content.forEach((content: any, eleIndex:number) => {
                if (content.typeOfQuestion !== undefined &&
                    content.typeOfQuestion !== null &&
                    !typeOfQuestion
                ) {
                    typeOfQuestion = content.typeOfQuestion;
                }
                if (content.subjects) {
                    convertSubjectWithId(content.subjects, conceptId, conceptCodes);
                }
                if (content.secondarySubjects){
                    convertSubjectWithId(content.secondarySubjects, conceptId, conceptCodes);
                }
            })
        }
        if (typeOfQuestion) {
            formData['passageQuestionType'] = getQuestionTypeName(parseInt(typeOfQuestion));
            formData['passageQuestionCode'] = typeOfQuestion;
        }
        contentService
            .addToQueueQuestion(formData, usersSelected, type)
            .then((res) => {
                if (res.statusCode == 422) {
                    this.setState({
                        isAlreadyInAddToQueue: true,
                        isAuthorDialogOpen: false,
                        alreadyInAddToQueueMsg: res.responseMessage
                    })
                } else {
                    this.setState({
                        // questionId: formData._id,
                        // isPublishedDialogOpen: true,
                        addToQueueStates: ADD_TO_QUEUE_STATES.DONE,
                        isAuthorDialogOpen: false,
                        isAlreadyInAddToQueue: false
                    })
                }
            });
        // this.setState({ selectedAuthors: authors });
    }

    addToQueueDone = (isOverRide: boolean) => {
        this.addToQueue(this.state.selectedAuthors, isOverRide)
    }

    canRePublishContent(e: any) {
        let { progressBarSetting } = this.state;
        if (progressBarSetting.barPercentage >= 100) {
            // this.beforeAuthorPublishDialogue();
            this.afterAuthorSelection(true, [this.props.authenticatedUser.id])
        }
    }

    RePublishContent = async (action: boolean, usersSelected: any) => {
        if (action) {
            const { formData } = this.props
            let { type } = this.props.queryParams;
            let authors = [usersSelected]
            formData.authors = usersSelected

            this.props.save && this.props.save(false).then((res: any) => {
                contentService.rePublish(formData, authors, type, true)
                    .then((res: any) => {
                        if (res.length > 1) {
                            res = res[0]
                        }
                        this.setState({ isPublishedDialogOpen: true, rePublishContentId: res.contentId });
                    });
            })
            this.setState({ selectedAuthors: authors });
        }
        this.setState({ isAuthorDialogOpen: false });
    }


    publishErrorClose() {
        this.setState({ draft100Percent: [] });
    }

    publishWarningClose = () => {
        this.setState({ draftLessThan100Percent: [] });
    }


    publishErrorRefresh = async () => {
        const questions = await contentService.publishContentRefresh({ "data": [...this.state.draftLessThan100Percent, ...this.state.draft100Percent] })
        const draftLessThan100Percent: any = []
        const draft100Percent: any = []
        questions.forEach((question: any) => {
            if (question.status === 'DRAFT') {
                if (question.completionPercent < 100) {
                    draftLessThan100Percent.push({
                        contentId: question.contentId,
                        _id: addQuestionStringInId(question._id),
                    })
                } else {
                    draft100Percent.push({
                        contentId: question.contentId,
                        _id: addQuestionStringInId(question._id),
                    })
                }
            }
        })
        this.setState({ draftLessThan100Percent, draft100Percent })
        return {
            updatedDraftLessThan100Percent: draftLessThan100Percent,
            updatedDraft100Percent: draft100Percent
        }
    }



    completeDraftQuestionPublish() {
        contentService.publishQuestions({ "data": this.state.draft100Percent }).then((res) => {
            if (res.ok === 1) {
                this.beforeAuthorPublishDialogue();
                this.publishErrorRefresh()
            }
        })
    }

    beforeAuthorPublishDialogue() {
        let { content } = this.props;
        if (["REVIEW"].includes(content.status)) {
            //"PUBLISHED", 
            return false;
        }
        let reviwers = ACLService.getUserReviewer();
        if (reviwers && reviwers.length > 0) {
            //content not eligible to publish 
            this.setState({ isReviwerDialogOpen: true });
        } else {
            this.setState({ isAuthorDialogOpen: true });
        }
    }

    handleParagraphQuestion = (passageData: any, contentRequestItemsIdForFirstTime: string, questionData: any, questionIndex: number) => {
        let reqBody = {};
        let contents: any = [];
        passageData.map((ele: any, index: number) => {
            contents.push({ sequenceNo: questionIndex, contentId: ele.content_Id })
        });
        reqBody = { ...reqBody, contents }
        const id = !questionData.contentRequestItemsId ? contentRequestItemsIdForFirstTime : questionData.contentRequestItemsId._id;
        contentRequestServices.createQuestionForPutContentRequest(id, { ...reqBody }).then((response: any) => {
            Promise.resolve(response);
        })
    }
    redirectToContentRequest = (res: any, type: any) => {
        if (type === 'question') {
            let passageData: any = [];
            const allStates: any = localStorage.getItem('allStates');
            const previousStates = JSON.parse(allStates);
            const { contentRequestData: { contentRequestData: { _id = '' } = {}, contentRequestAccordianData: { accordianTouched = [], accordianCreateTouched, accordianState = [], progressBarForQuestion, filteredQuestionArray, contentRequestItemsIdForFirstTime, removeUnresolvedFeedbackCount } }
            } = previousStates;
            const { history } = this.props;
            const { accordianIndex = 0, questionIndex = 1 } = accordianCreateTouched;
            let newUpdatedAccordianTouchedArray: any = [];
            let newQuestionFilter: any = [...filteredQuestionArray];
            accordianTouched.map((acc: any, index: number) => {
                if (acc.accordianIndex === accordianIndex) {
                    const { questionContent = [] } = acc;
                    const findQuestionIndex = questionContent.findIndex((element: any) => element.questionIndex === questionIndex);
                    if (index !== -1) {
                        const { content = [] } = res;
                        const rootParagraphQuestion = content.filter((ele: any) => ele.isParagraphRootNode);
                        const newUpdatedAttachedQuestion = {
                            content_Id: rootParagraphQuestion[0].paragraphQuestionId,
                            contentId: rootParagraphQuestion[0].contentId,
                            isJobCompleted: false,
                        }
                        newQuestionFilter.push({ content_Id: rootParagraphQuestion[0]._id, contentId: rootParagraphQuestion[0].contentId, contentSubTypeCode: 5 })
                        const newUpdatedAccordianTouchedObject = { ...newUpdatedAttachedQuestion };
                        let updatedQuestionContentArray = [...questionContent];
                        let unresolvedFeedbackCount = updatedQuestionContentArray[findQuestionIndex]['attachedQuestions'].unresolvedFeedbackCount;
                        updatedQuestionContentArray[findQuestionIndex] = {
                            ...updatedQuestionContentArray[findQuestionIndex], attachedQuestions: {
                                ...newUpdatedAccordianTouchedObject,
                                unresolvedFeedbackCount,
                                previousVersion: { ...updatedQuestionContentArray[findQuestionIndex]['attachedQuestions'].previousVersion }
                            }
                        }
                        newUpdatedAccordianTouchedArray = [...accordianTouched];
                        newUpdatedAccordianTouchedArray[index] = {
                            ...newUpdatedAccordianTouchedArray[index],
                            questionContent: [
                                ...updatedQuestionContentArray,
                            ]
                        }
                    }
                }
            });
            // this.handleParagraphQuestion(passageData, contentRequestItemsIdForFirstTime, accordianState[accordianIndex], questionIndex);
            const { setAccordingTouchIndex } = this.props;
            setAccordingTouchIndex(newUpdatedAccordianTouchedArray);
            setTimeout(() => {
                this.props.setAccordianState(accordianState);
                this.props.setProgressBarForQuestion(progressBarForQuestion);
                this.props.setContentRequestItemsIdForFirstTime({ id: contentRequestItemsIdForFirstTime });
            }, 200);
            this.props.setIsComingFrom({ booleanValue: true });
            this.props.setIsTabOpened({ booleanValue: true });
            this.props.setFilterQuestionArray(newQuestionFilter);
            this.props.setRemoveUnresolvedFeedbackCount({
                removeUnresolvedFeedbackCount
            })
            window.close();
            // history.push(`/contentRequest/owner-task/${_id}/creator`);

        } else {
            const allStates: any = localStorage.getItem('allStates');
            const previousStates = JSON.parse(allStates);
            const { contentRequestData: { contentRequestData: { _id = '' } = {}, contentRequestAccordianData: { accordianTest = [], contentRequestItemsIdForFirstTime = '', progressBarForTest = {}, accordianCreateTouched, removeUnresolvedFeedbackCountForTest } }
            } = previousStates;
            const { history, setIsComingFromTest } = this.props;
            const { accordianIndex = 0, questionIndex = 1 } = accordianCreateTouched;
            let newUpdatedAccordianTouchedArray: any = [];
            accordianTest.map((acc: any, index: number) => {
                if (acc.accordianIndex === accordianIndex) {
                    const { testContent = [] } = acc;
                    const findTestIndex = testContent.findIndex((element: any) => element.testIndex === questionIndex);
                    if (index !== -1) {

                        const newUpdatedAttachedQuestion = {
                            content_Id: res._id,
                            contentId: res.contentId,
                            isJobCompleted: false,
                        }
                        const newUpdatedAccordianTouchedObject = { ...newUpdatedAttachedQuestion };
                        let updatedQuestionContentArray = [...testContent];
                        let unresolvedFeedbackCount = updatedQuestionContentArray[findTestIndex]['attachedQuestions'].unresolvedFeedbackCount
                        updatedQuestionContentArray[findTestIndex] = {
                            ...updatedQuestionContentArray[findTestIndex], attachedQuestions: {
                                ...newUpdatedAccordianTouchedObject,
                                unresolvedFeedbackCount,
                                previousVersion: { ...updatedQuestionContentArray[findTestIndex]['attachedQuestions'].previousVersion }
                            }
                        }
                        newUpdatedAccordianTouchedArray = [...accordianTest];
                        newUpdatedAccordianTouchedArray[index] = {
                            ...newUpdatedAccordianTouchedArray[index],
                            testContent: [
                                ...updatedQuestionContentArray,
                            ]
                        }
                    }
                }
            })
            const { setTestAccordian } = this.props;
            ;
            setIsComingFromTest({ booleanValue: true });
            setTimeout(() => {
                this.props.setTestAccordian(newUpdatedAccordianTouchedArray)
                this.props.setProgressBarForTest(progressBarForTest);
            }, 200);
            this.props.setIsBothTabOpen({ booleanValue: true });
            this.props.setContentRequestItemsIdForFirstTime({ id: contentRequestItemsIdForFirstTime });
            this.props.setRemoveUnresolvedFeedbackCountForTest({
                removeUnresolvedFeedbackCountForTest
            })
            // history.push(`/contentRequest/owner-task/${_id}/creator`);
            window.close();
            this.contentRequestCount = this.contentRequestCount + 1;

        }

    }
   
    setCustomAnswerKey=(formData:ContentFormData)=>{
        const sectionsArray=_.get(formData,"data.sections",[]);
        sectionsArray.forEach((sec:any,index:number)=>{
           sec.subSection.forEach((subSec:any,innerIndx:number)=>{
                if(subSec.quesCodeAllowed===7){  
                   subSec.customAnswer=false;  
                   const customAns=_.get(subSec,"questions",[]).find((q:any)=>{
                      return _.get(q,"qId.content[0].customAnswer",false) ||_.get(q,"content_Id.customAnswer",false) ;
                   });
                   if(customAns){
                    subSec.customAnswer=true;
                   }else{
                    subSec.customAnswer=false;
                   }
                }
                if(index==sectionsArray.length-1 && innerIndx===subSec.length-1){
                  return Promise.resolve();
              }   
           });
           if(index==sectionsArray.length-1 && sec.subSection.length==0){
              return Promise.resolve();
           }  
        })
      }
     async publishContent(usersSelected: any) {
        let { subType, type } = this.props.queryParams;
        const { formData } = this.props;
        const { progressBarSetting, selectedAuthors } = this.state;
       
        if (type == "studymaterial" && subType != "notes") {
            type = subType;
        }
        let authors = [...selectedAuthors, usersSelected]
        formData.authors = usersSelected
         const isTeacher = checkForTeacherUser(this.props.content);
         const {content} = this.props;
         const isCreatorTeacher = getPropertyValue(content, 'contentTypeCode') === CONTENT_TYPE.QUESTION && getPropertyValue(content, 'isCreatorTeacher');
         formData.status =  (isTeacher || isCreatorTeacher) ? CONTENT_STATES.DRAFT : CONTENT_STATES.PUBLISHED;
        if (this.state.republishQueue) {
            formData.republishReason = this.state.republishQueue
        }
        if (formData._id) {
            if (type === REMEDIAL_PAGE_KEY.QUESTION && +subType === QUESTION_TYPES.PARAGRAPH) {
                this.formatDataForParagraphRemedialQuestion(formData);
            }
            formData.completionPercent = progressBarSetting.barLength;
            this.props.completionPercent(this.props.formData, progressBarSetting.barLength, usersSelected, "PUBLISHED");
            await this.setCustomAnswerKey(formData);
            this.props.save && this.props.save(false).then((res: any) => {
                const {formData, draftContentFormData} = this.props;
                const payload = Object.keys(draftContentFormData).length ? draftContentFormData : formData;
                const { publishQuestionDirectly } = this.state;
                if (publishQuestionDirectly) {
                  formData.publishBeforeValidation = true;
                }
                if (isTeacher || isCreatorTeacher) {
                    this.submitForValidation(payload, usersSelected);
                    return;
                  }
                contentService.publish(formData, usersSelected, type)
                    .then((response: any) => {
                        if (type = "question") {
                            this.setState({ questionId: formData._id })
                        }
                        if (this.props.queryParams.requestId) {
                            if (this.contentRequestCount === 0 && !this.props.fromFeedback) {
                                if (this.props.queryParams.type === 'question') {
                                    let response: any = { ...res }
                                    this.redirectToContentRequest(response, this.props.queryParams.type);
                                } else {
                                    this.redirectToContentRequest(response, this.props.queryParams.type);
                                }
                            }
                        }
                        if (this.props.fromFeedback && this.props.onFeedbackPublish) {
                            this.props.onFeedbackPublish();
                        } else {
                            this.setState({ isPublishedDialogOpen: true });
                        }
                    });
            })
            
        }
        this.setState({ selectedAuthors: authors, republishQueue: '' });
    }

    setReview(isSelected: boolean, userId: string) {
        let { formData } = this.props;
        if (isSelected && formData) {
            formData["contentReviewer"] = userId;
            formData["status"] = "REVIEW";
            this.setState({ isReviwerDialogOpen: false });
            this.props.updateFormData(formData, true);
        } else {
            this.setState({ isReviwerDialogOpen: false });
        }
    }

    moveToPlanned() {
        this.props.moveToPlanned();
    }



    hasAccessToPublished() {
        const { content, queryParams } = this.props;
        let { requestId } = queryParams;
        let reviwers = ACLService.getUserReviewer();
        let status = 'Publish';
        if (reviwers && reviwers.length > 0) {
            status = 'Submit for Review'
        }
        else if (requestId && requestId.startsWith('R-')) {
            status = 'Save & Next'
        }
        else {
            status = 'Publish'
        }
        if (["PUBLISHED", "REVIEW"].includes(content.status)) {
            status = 'Re-Publish';
        }
        return status;

    }
    getButtonText(contentType: string) {
        let { sliderData, currentTestNumber, currentQuestionNumber, authorType } = this.props;
        let contentTypeCondition: any = contentType === 'testpapers' ? currentTestNumber : currentQuestionNumber;
        if ((sliderData && sliderData.contents && sliderData.contents.length > 1) && (contentTypeCondition < sliderData.contents.length)) {
            if (authorType !== 'creator') {
                return 'Verify and Next'
            } else {
                return 'Save and Next'
            }
        } else {
            if (authorType !== 'creator') {
                return 'Verify and Proceed'
            } else {
                return 'Save and Proceed'
            }
        }
    }

    checkAccessToRePublish() {
        const { formData } = this.props;
        let status = false;
        if (formData.draftId || formData.publishId) {
            status = true
        }
        return status;
    }

    showMoveToPlanButton() {
        const { content } = this.props;
        const { inContent } = this.state;

        if (content.contentTypeCode != "testpapers") {
            return false;
        }

        if (["PUBLISHED", "REVIEW", "PLANNED"].includes(content.status)) {
            return false;
        }

        let c = inContent.filter((c: any) => ["basicInfo", "testFormat", "subjects"].includes(c.key))
            .filter((c: any) => c.state == statusType.success)
        if (c.length < 2) {
            return false;
        }

        return true;
    }

    handleHover() {
        this.setState({
            showTooltip: !this.state.showTooltip
        })
    }

    togglePublishDialogOpen = () => this.setState({ isPublishedDialogOpen: false })

    afterAuthorSelection = (isNotCancel: boolean, usersSelected: any) => {
        if (isNotCancel) {
            if (this._checkForAddToQueueModeActive()) {
                this.setState({
                    selectedAuthors: usersSelected,
                    addToQueueStates: ADD_TO_QUEUE_STATES.DIELOG_OPEN
                });
            } else if (this.props.formData.status === "PUBLISHED") {
                this.setState({
                    reasonRepublishPopup: true,
                    isAuthorDialogOpen: false,
                    userSelectedFromAuthors: usersSelected
                });
            } else {
                this.publishContent(this.state.userSelectedFromAuthors)
            }
        } else {
            this.setState({ isAuthorDialogOpen: false });
        }
    }

    _onClickPublishButton =async (isTemplateChange: boolean = true, shoudlAddBenchmarking = false) => {
        if (!this.props.fromFeedback || (this.props.fromFeedback && !this.checkDisabledConditionForNext())) {
            const { hasMyLibraryQueue, isTemplateChanged,formData } = this.props;
            const { progressBarSetting } = this.state;
            if(this.props.queryParams.type === "testpapers"){
                if(formData.previousExam && formData.previousExam.id && !formData.previousExam.year){
                  this.props.showMsg("Select atleast one value under Previous Year Test","error");
                  return ;
                }
              }
            // this.afterAuthorSelection(true, [this.props.authenticatedUser.id])
            if (!hasMyLibraryQueue) {
                if (progressBarSetting.barPercentage >= 100) {
                    const {content} = this.props;
                    const isTeacher = checkForTeacherUser(content);
                    const isCreatorTeacher = getPropertyValue(content, 'contentTypeCode') === CONTENT_TYPE.QUESTION && getPropertyValue(content, 'isCreatorTeacher');
                    const publishedContent = getPropertyValue(content, 'status','').toUpperCase() === CONTENT_STATUS.PUBLISH;
                    if(isTeacher || isCreatorTeacher) {
                        this.publishContent(this.state.userSelectedFromAuthors);
                        return;
                    }
                    if (
                        this._checkAccessToPublish()
                        || this.checkAccessToRePublish()
                        || this._checkForAddToQueueModeActive() || true
                    ) {
                        if ((((isTemplateChanged && isTemplateChange) || shoudlAddBenchmarking) && !publishedContent)) {
                            const { content, formData } = this.props
                            let courseId = formData.courseId && formData.courseId[0]
                            // if (_.get(content, "content.courseId[0]._id", null)) {
                            //     courseTypeId = content.content.courseId[0].courseType &&
                            //     content.content.courseId[0].courseType.id
                            // } else {
                            //     courseTypeId = content.content.courseData &&
                            //     content.content.courseData.courseType &&
                            //     content.content.courseData.courseType.id
                            // }
                            this.props.fetchGoalLevels({ params: { courseId } });
                            this.props.fetchBenchMarkInfo({
                                params: {type: 'test', typeId: content.content_Id}
                            });
                            this.props.save && this.props.save(false).then((res: any) => {
                                this.setState({
                                    isOpenBenchmarkDialog: true
                                })
                            })
                        } else {
                            // this.beforeAuthorPublishDialogue();
                            this.afterAuthorSelection(true, [this.props.authenticatedUser.id])
                        }
                    }
                }
            }

        }
    }

    checkDisabledConditionForNext() {
        return this.props.feedBackData && this.props.feedBackData.pendingFeedbacksCount !== 0
    }

    _checkAccessToPublish = () => {
        const { formData } = this.props;
        return formData.status === CONTENT_STATES.DRAFT
    }

    _checkRePublishMode = () => {
        const { formData } = this.props
        return formData.status == 'PUBLISHED'
    }

    _checkForAddToQueueModeActive = () => {
        // const {
        //     isValidAttempts,
        //     correctAnswer,
        //     defaultCorrectAnswer,
        //     alternateAnswer
        // } = this.props;
        // return isQuestionAddToQueueModeActive({
        //     isValidAttempts,
        //     correctAnswer,
        //     defaultCorrectAnswer,
        //     alternateAnswer
        // })
        const { formData, defaultCorrectAnswersForParagraph, isValidAttempts, originalFormData } = this.props;
        const correctAnswerForParagraph: any = formData.content.map((content: any) => {
            content = JSON.parse(JSON.stringify(content))
            if(content.correctAnswer) {
                delete content.correctAnswer._id
                return content.correctAnswer
            }
            return {};
        })
        let alternateAnswerParagraph = false;
        let changeInDifficultySkill = false;
        let changeInConcept = false;
        for (let i = 0; i < formData.content.length; i++) {
            if (formData.content[i].alternateAnswer) {
                alternateAnswerParagraph = true;
                formData.content[i].optionChange = false;
            }
            else{
                formData.content[i].optionChange = !checkIsCorrectAnswerChangeParagraph(defaultCorrectAnswersForParagraph, correctAnswerForParagraph);
            }
            if (originalFormData && originalFormData.content[i]) {
                const originalDifficultyLevel = originalFormData.content[i].difficultyLevel;
                const originalDifficultyType = originalFormData.content[i].difficultyType;
                const originalSubjects = originalFormData.content[i].subjects;
                const originalSecondarySubjects = originalFormData.content[i].secondarySubjects;
                const {
                    difficultyLevel,
                    difficultyType,
                    subjects,
                    secondarySubjects,
                } = formData.content[i];
                formData.content[i].conceptChange = isConceptAndChapterAddToQueueModeActive ({
                    subjects,
                    secondarySubjects,
                    originalSubjects,
                    originalSecondarySubjects,
                })
                if (formData.content[i].conceptChange) {
                    changeInConcept = true;
                }
                formData.content[i].difficultySkillLevelChange=isDifficultyAndSkillAddToQueueModeActive ({
                    difficultyLevel,
                    difficultyType,
                    originalDifficultyLevel,
                    originalDifficultyType,
                })
                if(formData.content[i].difficultySkillLevelChange) {
                    changeInDifficultySkill = true;
                }
            }
        }
        return formData.questionCode == QUESTION_TYPES.PARAGRAPH &&
            isValidAttempts && 
            ( isQuestionAddToQueueModeActiveParagraph({
                isValidAttempts,
                correctAnswer: correctAnswerForParagraph,
                defaultCorrectAnswer: defaultCorrectAnswersForParagraph,
                alternateAnswer: alternateAnswerParagraph
            }) || changeInConcept 
            || changeInDifficultySkill 
            )
    }

    _publishButtonCustomStyle = (progressBarSetting: any) => {
        const { hasMyLibraryQueue } = this.props;
        const { addToQueueStates } = this.state;
        const style = { color: '#666', cursor: 'default', opacity: 0.6 }
        if (progressBarSetting.barPercentage >= 100 && !hasMyLibraryQueue && addToQueueStates !== ADD_TO_QUEUE_STATES.DONE && !this.props.fromFeedback) {
            if (
                this._checkAccessToPublish()
                || this.checkAccessToRePublish()
                || this._checkForAddToQueueModeActive()
            ) {
                style.color = 'white'
                style.cursor = "pointer"
                style.opacity = 1
            }
        } else if (progressBarSetting.barPercentage >= 100 && !hasMyLibraryQueue && addToQueueStates !== ADD_TO_QUEUE_STATES.DONE && this.props.fromFeedback) {
            if (!this.checkDisabledConditionForNext() &&
                (this._checkAccessToPublish()
                    || this.checkAccessToRePublish()
                    || this._checkForAddToQueueModeActive())
            ) {
                style.color = 'white'
                style.cursor = "pointer"
                style.opacity = 1
            }
        }
        return style;
    }

    handleAddBenchMark() {
        // const {content} = this.props
        // this.props.fetchGoalLevels({params: {courseTypeId: 
        //   content.content.courseId &&
        //   content.content.courseId[0] &&
        //   content.content.courseId[0].courseType &&
        //   content.content.courseId[0].courseType.id
        // }})
    }

    handleUpdateBenchMark = (data: any) => {
        contentService.updateBenchMarkInfo(data).then(res => {
            if(res && res.statusCode === 200) {
                this.publishContent(this.state.userSelectedFromAuthors);
            }
        });
        // const {content} = this.props
        // this.props.fetchGoalLevels({params: {courseTypeId: 
        //   content.content.courseId &&
        //   content.content.courseId[0] &&
        //   content.content.courseId[0].courseType &&
        //   content.content.courseId[0].courseType.id
        // }})
    }

    handleUpdateBenchMarkComplete() {
        this.setState({
            // isBenchMarkUpdated: true,
            isOpenBenchmarkDialog: false,
        })
        this.props.templateChanged(false)
        this._onClickPublishButton(false)
    }

    globalFormData:any = {};
    inferDescriptiveValidation(data = [], formData = {}){
        this.globalFormData = formData;
        this.descriptiveValidation = {};
        for(let i=0; i < data.length; i++){
            let dataObj = data[i];
            if(!('typeOfQuestion' in dataObj)) continue;
            let subType = dataObj['subType'] || [];
            let collectiveBooleanFeedback = true;
            for(let ind = 0; ind < subType['length']; ind++){
                let { key } = subType[ind];
                if(!(i in this.descriptiveValidation)){
                    this.descriptiveValidation[i] = {};
                }
                // apply validation logic here!!!
                this.descriptiveValidation[i][key] = this.deduceValidationFromKey(key, i-1, ind);
                collectiveBooleanFeedback = collectiveBooleanFeedback && (this.descriptiveValidation[i][key]);
            }
            this.descriptiveValidation[i]['collectiveBooleanFeedback'] = collectiveBooleanFeedback;
            this.descriptiveValidation['collectiveBooleanFeedback'] = (this.descriptiveValidation['collectiveBooleanFeedback'] || true) && collectiveBooleanFeedback;
        }
    }

    deduceValidationFromKey(key = '', index = 0, i = 0){
        if(!key) return false;
        let validation;
        let accessorKey = this.globalFormData['content'][index];
        switch(key){
            case 'correctAnswer':
                validation = true;
                break;
            case 'questionContent':
                validation = !!(_.get(accessorKey,'questionContent','').length);
                break;
            case 'solutionContent':
                validation = !!(_.get(accessorKey,'stepWiseSolution[0].formulaUsed',[]).length);
                break;
            case 'subjects':
                validation = !!(accessorKey.subjects.length && accessorKey.subjects.find((subject: {
                    [x: string]: any; checked: any; 
                }) => subject.subjectId.checked));
                break;
            default:
                validation = true;
        }
        return validation;
    }
    submitToAnotherValidator = (progressBarSetting: any) => {
        this.setState({
          isChallengeRejectionModalOpen: false,
          submitToAnotherValidatorClicked: true,
        });
        this._onClickPublishButton(progressBarSetting);
      }

      submitForValidation(formData: any, usersSelected: any) {
        _.set(formData, 'content[0].benchmarks', this.props.finalQuestionBenchmarksPayload[formData._id]);
        const body = {
          ...formData,
          authors: usersSelected,
          contentType: 'question',
        };
        let publishDialogContent = !this.props.validationStatus ? CONTENT_SUBMIT_MODAL_BODY.SUBMIT : CONTENT_SUBMIT_MODAL_BODY.RE_SUBMIT;
        if (this.state.submitToAnotherValidatorClicked) {
          body.submitToAnotherValidator = true;
          publishDialogContent = CONTENT_SUBMIT_MODAL_BODY.SUBMIT_TO_ANOTHER_VALIDATOR;
        }
        if (this.state.publishQuestionDirectly) {
            publishDialogContent = CONTENT_SUBMIT_MODAL_BODY.DIRECT_PUBLISH
        }
        contentRequestServices.submitContentForValidation(body).then((res: any) => {
          this.setState({
            isPublishedDialogOpen: true,
            publishDialogBody: publishDialogContent.body,
            publishDialogHeading: publishDialogContent.heading,
          });
        })
      }

      handleSubmitForValidationClick = (progressBarSetting: any) => {
        const {publishQuestionDirectly} = this.state;
        if(publishQuestionDirectly) {
          this.setState({isPublishDirectlyModalOpen: true});
          return;
        }
        this._onClickPublishButton(progressBarSetting);
      }

      onPublishDirecltyModalClose = () => {
        this.setState({isPublishDirectlyModalOpen: false});
      }

      onPublishDirectlyClick = (progressBarSetting: any) => {
        this.setState({isPublishDirectlyModalOpen: false});
        this._onClickPublishButton(progressBarSetting);
      }    
    render() {
        const { classes, eventInContent, formData, queryParams: history, isTemplateChanged,
            hasMyLibraryQueue, queryParams, content, fromURL, selectedQuestionsList, publishedStateQuestion, draftStateQuestion, completeDraftStateQuestion, goalLevels } = this.props;
        const { inContent,
            showTooltip,
            rePublishContentId,
            progressBarSetting,
            isAuthorDialogOpen,
            isPublishedDialogOpen,
            isReviwerDialogOpen,
            selectedAuthors,
            questionId,
            addToQueueStates,
            isAlreadyInAddToQueue,
            alreadyInAddToQueueMsg,
            isBenchMarkUpdated,
            isOpenBenchmarkDialog,
            isChallengeRejectionModalOpen,
            publishDialogBody,
            publishDialogHeading,
            publishQuestionDirectly,
            isPublishDirectlyModalOpen,
            disablePubliushDirectlyButton,
        } = this.state;
        let { subType, type } = this.props.queryParams;
        const otherDialogProps = {
            fullWidth: true,
            maxWidth: 'md',
            scroll: 'body',
        };
        let headerIndex = 0;
        let subHeaderIndex=0;

        const isTeacher = checkForTeacherUser(this.props.content);
        const isStudentUser = getUserType(USER_TYPE.STUDENT);
        const isCreatorTeacher = getPropertyValue(content, 'contentTypeCode') === CONTENT_TYPE.QUESTION && getPropertyValue(content, 'isCreatorTeacher');
        const contentStatus = getPropertyValue(this.props.content, 'status', '').toUpperCase();
        const validationStatus = getPropertyValue(this.props.content, 'validationStatus', '').toUpperCase();
        const rejectedContentStatus = [contentStatus, validationStatus].includes(FEEDBACK_VALIDATOR_ACTIONS.REJECTED.toUpperCase());
        const bucketType = content.specialPurposes && content.specialPurposes[0];
        const isNationalLevelOrAITS = [CONTENT_SECTION_KEYS.NATIONAL_LEVEL_TEST].includes(bucketType);
        const isDraft = content.status === CONTENT_STATES.DRAFT;
        const isTestpaperType = getPropertyValue(content, 'contentTypeCode') === AUTHORING_CONTENT_TYPES.GLORIFIRE_TESTPAPERS;
        const shouldAddBenchmarking = isNationalLevelOrAITS && isDraft && isTestpaperType && goalLevels && goalLevels.hasGoalLevels;

        return (

            <>
                <Stepper
                    className={classes.overflowSection}
                    connector={
                        <StepConnector
                            classes={{
                                disabled: classes.stepDisabled,
                                line: classes.connectorLine,
                            }}
                        />
                    }
                    orientation="vertical"
                >
                    {inContent.map((label: any) => {
                        subHeaderIndex++;
                        if (label.visible) {
                            headerIndex++;
                            return (
                                <Step key={headerIndex}>
                                    {this.stepLabelType(label.title, label.state, headerIndex - 1,'',label.order)}
                                    {_.map(label.subType, (ob, i) => {
                                        if (ob.visible) {
                                            return (
                                                <Stepper
                                                    key={`${subHeaderIndex}_${i}`}
                                                    className={classes.p15}
                                                    orientation="vertical"
                                                >
                                                    <Step key={`${i}_${subHeaderIndex}`}>
                                                        {this.stepLabelType(ob.title, ob.state, subHeaderIndex - 1, i)}
                                                    </Step>
                                                </Stepper>
                                            );
                                        }
                                    })}
                                </Step>
                            );
                        }
                    })
                }
                </Stepper>
                {/* <div
              onClick={() => {
                this._onClickPublishButton();
              }}
              className={classes.positionRl}
            > */}
                {/* <LinearProgress
                classes={{ root: classes.progressBar }}
                variant="determinate"
                value={progressBarSetting.barLength}
              /> */}
                {/* <Typography
                className={classes.positionAb}
                variant="subtitle1"
                align="center"
              >
                {progressBarSetting.barLength > 0 ? (
                  progressBarSetting.barLength >= 100 ? (
                    <Check
                      className={`${classes.icon} ${
                        classes.successIcon
                      }`}
                    />
                  ) : (
                    `${progressBarSetting.barPercentage}%`
                  )
                ) : (
                  "0%"
                )}
              </Typography> */}
                {/* <div
                onMouseOver={this.handleHover.bind(this)}
                onMouseOut={this.handleHover.bind(this)}
                className={classes.rePublishButton}
              > */}
                {/* { color: 'white', cursor: progressBarSetting.barPercentage != 100 ? "default" : "pointer", opacity: this.checkRePublishMode() && !this.checkAccessToRePublish() ? 0.6 : 1 } */}
                {/* <Typography
                  style={this._publishButtonCustomStyle(
                    progressBarSetting
                  )}
                  className={classes.publishedLabel}
                  variant="subtitle1"
                  align="center"
                >
                  {!this.props.fromFeedback
                    ? this.hasAccessToPublished()
                    : this.getButtonText("testpapers")}
                </Typography> */}
                {/* </div> */}
                {/* {
                <Prompt
                  when={this._checkForAddToQueueModeActive()}
                  message="You have unsaved changes, are you sure you want to leave?"
                />
              } */}

                {/* {showTooltip &&
              (hasMyLibraryQueue ||
                addToQueueStates === ADD_TO_QUEUE_STATES.DONE) ? (
                <>
                  <Grid className={classes.tootipContainer}>
                    <CustomInfoIcon
                      isInfoIcon={false}
                      isCenterArrow={true}
                      isRightArrow={false}
                      isLeftArrow={false}
                      details='This content is a part of the "Republish Queue" already. Please republish this content from there or remove it to add it to the queue again.'
                      toolTipDirection="bottom"
                    />
                  </Grid>{" "}
                </>
              ) : (
                ""
              )} */}
                {/* <Typography variant="caption" align="center">
                Reach 100% progress to publish the content
              </Typography> */}
                {/* </div> */}

                {(isTemplateChanged || shouldAddBenchmarking) && isOpenBenchmarkDialog && (
                    <Benchmark
                        content={{content: formData}}
                        isOpen={this.state.isOpenBenchmarkDialog}
                        onAdd={this.handleAddBenchMark.bind(this)}
                        onUpdate={(data: any) =>
                            this.handleUpdateBenchMark(data)
                        }
                        onUpdateComplete={this.handleUpdateBenchMarkComplete.bind(
                            this
                        )}
                        onClose={() =>
                            this.setState({ isOpenBenchmarkDialog: false })
                        }
                        addBenchmarkFromTest={true}
                    />
                )}

                {/* {this.showMoveToPlanButton() && (
                    <div className={classes.moveToPlannedContainer}>
                        <span className={classes.moveToPlannedOr}>OR</span>
                        <Button
                            variant="outlined"
                            color="primary"
                            className={classes.moveToPlanned}
                            onClick={() => {
                                this.moveToPlanned();
                            }}
                        >
                            Move to Planned
                  <Tooltip
                                placement="right-start"
                                title="A test is eligible to be moved to planned status after completing the section number 1, 2 and 4."
                            >
                                <InfoIcon className={classes.ml1x} />
                            </Tooltip>
                        </Button>
                    </div>
                )} */}

                {/* add author then add publish content */}
                <MyPATDialog
                    dialogHeading="Publish Error"
                    dialogOpen={this.state.draftLessThan100Percent.length > 0}
                    otherDialogProps={otherDialogProps}
                    dialogHasActions={true}
                    onDialogClose={this.publishWarningClose}
                    onDialogBack={this.dialogueDraftQuestionBack}
                >
                    <div className={classes.modalBody}>
                        <img src="https://mypat-v2-prod.s3-us-west-2.amazonaws.com/webcontent/web_img/warning_icon.svg" />
                        <p className={classes.publishText}>
                            Following questions are incomplete and hence cannot be
                            published. Please visit these questions individually
                            and complete all the necessary sections to publish
                            this test.
                </p>
                        <div className={classes.quesIdContainer}>
                            {this.state.draftLessThan100Percent.map(function (
                                name: any,
                                index: number
                            ) {
                                return (
                                    <a
                                        href={`/content/preview/${name._id}`}
                                        target="_blank"
                                        className={classes.quesId}
                                    >
                                        Q.{index + 1} - ID: {name.contentId}
                                    </a>
                                );
                            })}
                        </div>
                        <div className={classes.modalFooter}>
                            <button
                                className={classes.refreshBtn}
                                onClick={this.publishErrorRefresh}
                            >
                                Refresh
                  </button>
                            <button
                                className={classes.okBtn}
                                onClick={this.publishWarningClose}
                            >
                                Ok
                  </button>
                        </div>
                    </div>
                </MyPATDialog>
                <MyPATDialog
                    dialogHeading="Warning"
                    dialogOpen={
                        this.state.draft100Percent.length > 0 &&
                        this.state.draftLessThan100Percent.length === 0
                    }
                    otherDialogProps={otherDialogProps}
                    dialogHasActions={true}
                    onDialogClose={this.publishErrorClose}
                    onDialogBack={() => {
                        this.dialogueCompleteDraftQuestionBack;
                    }}
                >
                    <div className={classes.modalBody}>
                        <img src="https://mypat-v2-prod.s3-us-west-2.amazonaws.com/webcontent/web_img/warning_alarm_icon.svg" />
                        <p className={classes.publishText}>
                            Following questions are incomplete and hence cannot be
                            published. Please visit these questions individually
                            and complete all the necessary sections to publish
                            this test.
                </p>
                        <div className={classes.quesIdContainer}>
                            {this.state.draft100Percent.map(function (
                                name: any,
                                index: number
                            ) {
                                return (
                                    <a
                                        href={`/content/preview/${name._id}`}
                                        target="_blank"
                                        className={classes.quesId}
                                    >
                                        Q.{index + 1} - ID: {name.contentId}
                                    </a>
                                );
                            })}
                        </div>
                        <div className={classes.modalFooter}>
                            <button
                                className={classes.okBtn}
                                onClick={this.completeDraftQuestionPublish}
                            >
                                Ok
                  </button>
                        </div>
                    </div>
                </MyPATDialog>
                <ContentAuthorModal
                    onAuthorSelected={this.afterAuthorSelection}
                    //onAuthorSelected={this.checkAccessToRePublish() ? this.RePublishContent : this.publishContent}
                    isAuthorDialogOpen={isAuthorDialogOpen}
                />
                {addToQueueStates === ADD_TO_QUEUE_STATES.DIELOG_OPEN && (
                    <AddToQueueQuestion
                        addToQueueCancel={this.addToQueueCancel}
                        addToQueueDone={this.addToQueueDone}
                        contentId={formData._id}
                        isAlreadyInAddToQueue={isAlreadyInAddToQueue}
                        alreadyInAddToQueueMsg={alreadyInAddToQueueMsg}
                    />
                )}
                {
                    <MyPATDialog
                        dialogOpen={this.state.reasonRepublishPopup}
                        dialogHasActions={true}
                        dialogHeading={
                            <Typography className={classes.republishTitle}>
                                Reason for Re-Publish
                  </Typography>
                        }
                        isAlignCenter={true}
                        customButtonVariant="withoutBorderCloseIcon"
                        isCustomBackground={false}
                        onDialogClose={this.closeRepublishDialog.bind(this)}
                        isborderDialogAction={true}
                        customDialogActions={
                            <>
                                <Grid
                                    container
                                    justify="flex-end"
                                    alignItems="flex-end"
                                >
                                    <Button
                                        color="primary"
                                        className={classes.cancelBorder}
                                        onClick={this.closeRepublishDialog.bind(this)}
                                    >
                                        Cancel
                      </Button>
                                    <Button
                                        variant="contained"
                                        onClick={this.rePublish.bind(this)}
                                        color="primary"
                                    >
                                        Re-publish
                      </Button>
                                </Grid>
                            </>
                        }
                    >
                        <Grid
                            container
                            spacing={8}
                            className={classes.customRepublishDialog}
                        >
                            <Grid item xs={12}>
                                <MyPATTextArea
                                    inputId="republishReason"
                                    name="republishReason"
                                    placeholder="Enter reason here (Optional)"
                                    onChange={this.handleRepublishQueueChange.bind(
                                        this
                                    )}
                                    value={this.state.republishQueue}
                                    multiline
                                    fullWidthControl
                                    className={classes.customTextarea}
                                    rows="4"
                                />
                            </Grid>
                        </Grid>
                    </MyPATDialog>
                }

                <ContentPublishedModal
                    publishId={formData.publishId}
                    rePublishContentId={rePublishContentId}
                    isPublishedDialogOpen={isPublishedDialogOpen}
                    content={formData}
                    queryParams={queryParams}
                    history={history}
                    fromURL={fromURL}
                    togglePublishDialogOpen={this.togglePublishDialogOpen}
                    authors={selectedAuthors}
                    questionId={questionId}
                    headingText={publishDialogHeading}
                    bodyText={publishDialogBody}
                />
                <ContentReviwerModal
                    onReviewSelected={this.setReview}
                    isReviwerDialogOpen={isReviwerDialogOpen}
                />

                <Grid container className={[classes.footerFixed, isTeacher && this.props.canSubmitToAnotherValidator ? classes.footerForReValidation : ''].join(" ")}>
                    {isTeacher && rejectedContentStatus && <p className='instruction'>Click on individual feedback and resolve/challenge all the feedback before proceeding further.</p>}
                    {isTeacher && !isStudentUser && content.status === CONTENT_STATES.DRAFT && !content.validationStatus &&
                      <div className={classes.directPublish}>
                        <span className={classes.directPublishText} >Publish this question within your centre directly to use it in a test or an assignment, while a duplicate of this question is undergoing validation</span>
                        <Switch
                          checked={publishQuestionDirectly}
                          disabled={disablePubliushDirectlyButton}
                          onChange={() => { this.setState({ publishQuestionDirectly: !publishQuestionDirectly }) }}
                          value="publishDirect"
                          color="primary"
                          classes={{
                            switchBase: classes.iOSSwitchBase,
                            bar: classes.iOSBar,
                            icon: classes.iOSIcon,
                            iconChecked: classes.iOSIconChecked,
                            checked: classes.iOSChecked,
                          }}
                        />
                      </div>
                    }
                    <Grid item>
                        <Grid className={classes.displayFlex}>
                            <LinearProgress
                                classes={{
                                    colorSecondary: classes.colorprimary,
                                    barColorPrimary: classes.colorprimary,
                                    bar: classes.progressBar,
                                    root: classes.linearProgressBar,
                                }}
                                variant="determinate"
                                value={progressBarSetting.barLength}
                            />
                            <Typography
                                //   className={classes.positionAb}
                                //   variant="subtitle1"
                                align="center"
                            >
                                Progress: {progressBarSetting.barPercentage} %
                  </Typography>
                        </Grid>
                    </Grid>
                    {(!isTeacher && !isCreatorTeacher) ? <Grid item>
                        <Button
                            color="primary"
                            variant="contained"
                            disabled={progressBarSetting.barPercentage < 100 || (this.props.fromFeedback && this.checkDisabledConditionForNext())}
                            onClick={() => {
                                this._onClickPublishButton(true, shouldAddBenchmarking);
                            }}
                        >
                            {shouldAddBenchmarking ? 'Save and Next' : (
                                !this.props.fromFeedback
                                    ? this.hasAccessToPublished()
                                    : this.getButtonText("testpapers"))}
                        </Button>
                    </Grid>
                    :      <>
                    {
                      (!this.props.validationStatus || this.props.validationStatus === FEEDBACK_VALIDATOR_ACTIONS.PUBLISHED) && (
                        <Grid item>
                          <Button
                            color="primary"
                            variant="contained"
                            disabled={progressBarSetting.barPercentage < 100} 
                            onClick={() => this.handleSubmitForValidationClick(progressBarSetting)}
                          >
                            {QUESTION_SUBMIT.SUBMIT_FOR_VALIDATION}
                          </Button>
                        </Grid>
                      )
                    }
                    {
                      (this.props.validationStatus === FEEDBACK_VALIDATOR_ACTIONS.REJECTED) && (
                        <>
                          {
                            this.props.canSubmitToAnotherValidator && (
                              <Grid item>
                                <Button
                                  color="primary"
                                  variant="outlined"
                                  className={classes.btnText}
                                  disabled={progressBarSetting.barPercentage < 100 || this.props.pendingValidationComments } 
                                  onClick={()=>this.setState({isChallengeRejectionModalOpen: true})}
                                >
                                  Submit to Another Validator
                                </Button>
                              </Grid>
                            )
                          }
                          <Grid item>
                            <Button
                              color="primary"
                              variant="contained"
                              className={classes.btnFill}
                              disabled={progressBarSetting.barPercentage < 100 || this.props.pendingValidationComments } 
                              onClick={() => {
                                this._onClickPublishButton(progressBarSetting);
                              }}
                            >
                              Resubmit to Same Validator
                            </Button>
                          </Grid>
                        </>
                      )
                    }

                    <MyPATDialog
                      dialogOpen= {isChallengeRejectionModalOpen}
                      otherDialogProps={{
                        fullWidth: true,
                        maxWidth: 'sm',
                      }}
                    >
                      <Grid>
                        <div className={classes.rejectionModal}>
                          <img src="/assets/svg/contentValidation/challenge-rejection-icon.svg" alt="Challenge Rejection" />
                          <h2>Challenge Rejection</h2>
                          <p>Do you really want to challenge the feedback by sending it to another validator? Only feedback with the challenged status will be sent for the final decision.</p>
                          <div className={classes.rejectionModalFooter}>
                            <Button className='modalBtnText' color="primary" onClick={()=>this.setState({isChallengeRejectionModalOpen: false})}>No</Button>
                            <Button className='modalBtnFill' color="primary" onClick={()=>this.submitToAnotherValidator(progressBarSetting)}>Yes</Button>
                          </div>
                        </div>
                      </Grid>
                    </MyPATDialog>
                  </>
                    }
                </Grid>
                <PublishContentDirecltyModal isModalOpen={isPublishDirectlyModalOpen} onModalClose={this.onPublishDirecltyModalClose.bind(this)} onDeclarationAccept={this.onPublishDirectlyClick.bind(this, progressBarSetting)}/>

                {/* </MyPATCollapse> */}
            </>
        );
    }

}
const mapStateToProps = (state: any) => {
    return {
        focusedSection: state.commonData.focusedSection,
        goalLevels: _.get(state, "mylibraryData.content.goalLevels"),
        eventInContent: _.get(state, 'mylibraryData.contentInSection.list', {}),
        paragraphInSection: _.get(state, 'mylibraryData.contentInParagraphSection.list', {}),
        tagsList: _.get(state, 'mylibraryData.contentTags.list', []),
        testSubjects: _.get(state, "mylibraryData.syllabus.subjects.subjects", []),
        isValidAttempts: state.questionCreate.isValidAttempts,
        notesSubTypes: _.get(state, 'studyNotedReducers.subTypes', []),
        isTemplateChanged: _.get(state, "mylibraryData.content.isTemplateChanged", false),
        isQuestionUpdated: _.get(state, "mylibraryData.content.isQuestionUpdated", false),  
        /* TODO: uncomment later when data loss issue fix */
        // formData: _.get(state, "mylibraryData.content.formData", {})
        authenticatedUser:
            state.loginData.userData &&
            state.loginData.userData.authenticatedUser,
        accordianTouched: _.get(state, 'contentRequestData.contentRequestAccordianData.accordianTouched', []),
        accordianCreateTouched: _.get(state, 'contentRequestData.contentRequestAccordianData.accordianCreateTouched', []),
        accordianTest: _.get(state, 'contentRequestData.contentRequestAccordianData.accordianTest', []),
        finalQuestionBenchmarksPayload: state.questionCreate.finalQuestionBenchmarksPayload,
        remedialQuestionIds:  state.questionCreate.remedialQuestionIds
    }
};

const mapDispatchToProps = (dispatch: any) => bindActionCreators({
    fetchGoalLevels: contentActions.fetchGoalLevels,
    updateBenchMarkInfo: contentActions.updateBenchMarkInfo,
    fetchBenchMarkInfo: contentActions.fetchBenchMarkInfo,
    templateChanged: contentActions.templateChanged,
    questionCompleted: contentActions.questionCompleted,
    setIsComingFrom: contentRequestAccordianActions.setIsComingFrom,
    setIsComingFromTest: contentRequestAccordianActions.setIsComingFromTest,
    setAccordianTouchWhileCreate: contentRequestAccordianActions.setAccordianTouchWhileCreate,
    setTestAccordian: contentRequestAccordianActions.setTestAccordian,
    setIsBothTabOpen: contentRequestAccordianActions.setIsBothTabOpen,
    setProgressBarForTest: contentRequestAccordianActions.setProgressBarForTest,
    setAccordingTouchIndex: contentRequestAccordianActions.setAccordingTouchIndex,
    setIsTabOpened: contentRequestAccordianActions.setIsTabOpened,
    setProgressBarForQuestion: contentRequestAccordianActions.setProgressBarForQuestion,
    setAccordianState: contentRequestAccordianActions.setAccordianState,
    setFilterQuestionArray: contentRequestAccordianActions.setFilterQuestionArray,
    setContentRequestItemsIdForFirstTime: contentRequestAccordianActions.setContentRequestItemsIdForFirstTime,
    setRemoveUnresolvedFeedbackCount: contentRequestAccordianActions.setRemoveUnresolvedFeedbackCount,
    setRemoveUnresolvedFeedbackCountForTest: contentRequestAccordianActions.setRemoveUnresolvedFeedbackCountForTest,
    showMsg: showAlert,
}, dispatch);


// @ts-ignore
export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(SectionsInContent));
